/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * RheumHub API - Rheumatology platform for nurses and patients in the UK
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptPatientInvitationResult,
  ActivePracticeResult,
  AdminListSafetyReportsParams,
  AdminListUsersParams,
  AdminUpdateSafetyReportInput,
  AdminUserProfile,
  ApprovalActionInput,
  CancelPatientInvitation200,
  CheckInteractionsParams,
  CompetencyDomain,
  CompetencyStatementWithEntry,
  Condition,
  ConfirmUploadRequest,
  ConfirmUploadResult,
  ConsultationGpLetter,
  ConsultationRecord,
  CpdModule,
  CpdModuleProgress,
  CpdModuleSummary,
  CreateConsultationRecordInput,
  CreatePatientInvitationInput,
  CreatePatientInvitationResult,
  CreatePracticeInput,
  CreateSafetyReportNoteInput,
  DeleteUserDataInput,
  DoctorCpdActivity,
  DoctorCpdActivityInput,
  DoctorCpdSummary,
  DoctorCurriculumEntry,
  DoctorCurriculumEntryInput,
  ErrorResponse,
  Event,
  EvidenceUploadForm,
  GetOtCpdSummaryParams,
  GetPharmacistCpdSummaryParams,
  GetPhysioCpdSummaryParams,
  GetPortfolioSummaryParams,
  GlobalSearchParams,
  Guideline,
  GuidelinesSummary,
  HcpProfile,
  HcpProfileSummary,
  HcpProfileUpdate,
  HealthStatus,
  Hospital,
  InteractionResult,
  InvitePracticeMemberInput,
  ListConditionsParams,
  ListDoctorCpdActivitiesParams,
  ListEventsParams,
  ListGuidelinesParams,
  ListHospitalsParams,
  ListIncomingPatientRequestsParams,
  ListMedicationsParams,
  ListModulesParams,
  ListOtCpdActivitiesParams,
  ListPharmacistCounsellingChecklistsParams,
  ListPharmacistCpdActivitiesParams,
  ListPhysioCpdActivitiesParams,
  ListResourcesParams,
  ListScenariosParams,
  ListSupplyCompaniesParams,
  Medication,
  NurseDashboard,
  OdsOrganisation,
  OpenaiConversation,
  OpenaiConversationInput,
  OpenaiConversationWithMessages,
  OpenaiError,
  OpenaiMessage,
  OpenaiMessageInput,
  OtCpdActivity,
  OtCpdActivityInput,
  OtCpdSummary,
  OtPortfolioEntry,
  OtPortfolioEntryInput,
  OtReflection,
  OtReflectionInput,
  OtSettings,
  OtSettingsInput,
  PatientDashboard,
  PatientInvitation,
  PatientInvitationPreview,
  PatientPreConsultSummary,
  PatientRequest,
  PharmacistCounsellingChecklist,
  PharmacistCpdActivity,
  PharmacistCpdActivityInput,
  PharmacistCpdSummary,
  PharmacistPortfolioEntry,
  PharmacistPortfolioEntryInput,
  PhysioCpdActivity,
  PhysioCpdActivityInput,
  PhysioCpdSummary,
  PhysioPortfolioEntry,
  PhysioPortfolioEntryInput,
  PortfolioDomainSummary,
  PortfolioEntry,
  PortfolioEntryDetail,
  PortfolioEntryInput,
  PortfolioEvidence,
  PortfolioExport,
  Practice,
  PracticeMember,
  PracticeWithMemberCount,
  PracticeWithMembership,
  RequestUserDataDeletionResult,
  RequestVerificationReviewResult,
  Resource,
  SafetyReport,
  SafetyReportNote,
  Scenario,
  SearchOrganisationsParams,
  SearchResultItem,
  SendWorkEmailOtpInput,
  SendWorkEmailOtpResult,
  SetActivePracticeInput,
  SetRoleInput,
  SubmitPatientRequestInput,
  SubmitSafetyReportInput,
  SupplyCompany,
  UpdateConsultationRecordInput,
  UpdateModuleProgressInput,
  UpdateSafetyReportNoteInput,
  UpdateUserPreferencesInput,
  UploadUrlRequest,
  UploadUrlResponse,
  UserDataDeleteResult,
  UserDataExport,
  UserDataSummary,
  UserPreferences,
  UserProfile,
  VerifyRegistrationInput,
  VerifyRegistrationResult,
  VerifyWorkEmailOtpInput,
  VerifyWorkEmailOtpResult,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List practices the current user belongs to (active or invited)
 */
export const getListMyPracticesUrl = () => {
  return `/api/practices`;
};

export const listMyPractices = async (
  options?: RequestInit,
): Promise<PracticeWithMembership[]> => {
  return customFetch<PracticeWithMembership[]>(getListMyPracticesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyPracticesQueryKey = () => {
  return [`/api/practices`] as const;
};

export const getListMyPracticesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyPractices>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyPractices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyPracticesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPractices>>> = ({
    signal,
  }) => listMyPractices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyPractices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyPracticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyPractices>>
>;
export type ListMyPracticesQueryError = ErrorType<void>;

/**
 * @summary List practices the current user belongs to (active or invited)
 */

export function useListMyPractices<
  TData = Awaited<ReturnType<typeof listMyPractices>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyPractices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyPracticesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new practice and make the current user its lead
 */
export const getCreatePracticeUrl = () => {
  return `/api/practices`;
};

export const createPractice = async (
  createPracticeInput: CreatePracticeInput,
  options?: RequestInit,
): Promise<Practice> => {
  return customFetch<Practice>(getCreatePracticeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPracticeInput),
  });
};

export const getCreatePracticeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPractice>>,
    TError,
    { data: BodyType<CreatePracticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPractice>>,
  TError,
  { data: BodyType<CreatePracticeInput> },
  TContext
> => {
  const mutationKey = ["createPractice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPractice>>,
    { data: BodyType<CreatePracticeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createPractice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPractice>>
>;
export type CreatePracticeMutationBody = BodyType<CreatePracticeInput>;
export type CreatePracticeMutationError = ErrorType<void>;

/**
 * @summary Create a new practice and make the current user its lead
 */
export const useCreatePractice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPractice>>,
    TError,
    { data: BodyType<CreatePracticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPractice>>,
  TError,
  { data: BodyType<CreatePracticeInput> },
  TContext
> => {
  return useMutation(getCreatePracticeMutationOptions(options));
};

/**
 * @summary Switch the current user's active practice context
 */
export const getSetActivePracticeUrl = () => {
  return `/api/practices/active`;
};

export const setActivePractice = async (
  setActivePracticeInput: SetActivePracticeInput,
  options?: RequestInit,
): Promise<ActivePracticeResult> => {
  return customFetch<ActivePracticeResult>(getSetActivePracticeUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setActivePracticeInput),
  });
};

export const getSetActivePracticeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setActivePractice>>,
    TError,
    { data: BodyType<SetActivePracticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setActivePractice>>,
  TError,
  { data: BodyType<SetActivePracticeInput> },
  TContext
> => {
  const mutationKey = ["setActivePractice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setActivePractice>>,
    { data: BodyType<SetActivePracticeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return setActivePractice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetActivePracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof setActivePractice>>
>;
export type SetActivePracticeMutationBody = BodyType<SetActivePracticeInput>;
export type SetActivePracticeMutationError = ErrorType<void>;

/**
 * @summary Switch the current user's active practice context
 */
export const useSetActivePractice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setActivePractice>>,
    TError,
    { data: BodyType<SetActivePracticeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setActivePractice>>,
  TError,
  { data: BodyType<SetActivePracticeInput> },
  TContext
> => {
  return useMutation(getSetActivePracticeMutationOptions(options));
};

/**
 * @summary List members and pending invites for a practice (member-only)
 */
export const getListPracticeMembersUrl = (id: number) => {
  return `/api/practices/${id}/members`;
};

export const listPracticeMembers = async (
  id: number,
  options?: RequestInit,
): Promise<PracticeMember[]> => {
  return customFetch<PracticeMember[]>(getListPracticeMembersUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListPracticeMembersQueryKey = (id: number) => {
  return [`/api/practices/${id}/members`] as const;
};

export const getListPracticeMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listPracticeMembers>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPracticeMembers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPracticeMembersQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPracticeMembers>>
  > = ({ signal }) => listPracticeMembers(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPracticeMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPracticeMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPracticeMembers>>
>;
export type ListPracticeMembersQueryError = ErrorType<void>;

/**
 * @summary List members and pending invites for a practice (member-only)
 */

export function useListPracticeMembers<
  TData = Awaited<ReturnType<typeof listPracticeMembers>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPracticeMembers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPracticeMembersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Invite a clinician to join the practice by email (lead only)
 */
export const getInvitePracticeMemberUrl = (id: number) => {
  return `/api/practices/${id}/members`;
};

export const invitePracticeMember = async (
  id: number,
  invitePracticeMemberInput: InvitePracticeMemberInput,
  options?: RequestInit,
): Promise<PracticeMember> => {
  return customFetch<PracticeMember>(getInvitePracticeMemberUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(invitePracticeMemberInput),
  });
};

export const getInvitePracticeMemberMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitePracticeMember>>,
    TError,
    { id: number; data: BodyType<InvitePracticeMemberInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitePracticeMember>>,
  TError,
  { id: number; data: BodyType<InvitePracticeMemberInput> },
  TContext
> => {
  const mutationKey = ["invitePracticeMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitePracticeMember>>,
    { id: number; data: BodyType<InvitePracticeMemberInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return invitePracticeMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitePracticeMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitePracticeMember>>
>;
export type InvitePracticeMemberMutationBody =
  BodyType<InvitePracticeMemberInput>;
export type InvitePracticeMemberMutationError = ErrorType<void>;

/**
 * @summary Invite a clinician to join the practice by email (lead only)
 */
export const useInvitePracticeMember = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitePracticeMember>>,
    TError,
    { id: number; data: BodyType<InvitePracticeMemberInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof invitePracticeMember>>,
  TError,
  { id: number; data: BodyType<InvitePracticeMemberInput> },
  TContext
> => {
  return useMutation(getInvitePracticeMemberMutationOptions(options));
};

/**
 * @summary Remove a member or cancel an invite (lead only)
 */
export const getRemovePracticeMemberUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/practices/${id}/members/${membershipId}`;
};

export const removePracticeMember = async (
  id: number,
  membershipId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemovePracticeMemberUrl(id, membershipId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemovePracticeMemberMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePracticeMember>>,
    TError,
    { id: number; membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removePracticeMember>>,
  TError,
  { id: number; membershipId: number },
  TContext
> => {
  const mutationKey = ["removePracticeMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removePracticeMember>>,
    { id: number; membershipId: number }
  > = (props) => {
    const { id, membershipId } = props ?? {};

    return removePracticeMember(id, membershipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemovePracticeMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removePracticeMember>>
>;

export type RemovePracticeMemberMutationError = ErrorType<void>;

/**
 * @summary Remove a member or cancel an invite (lead only)
 */
export const useRemovePracticeMember = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePracticeMember>>,
    TError,
    { id: number; membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removePracticeMember>>,
  TError,
  { id: number; membershipId: number },
  TContext
> => {
  return useMutation(getRemovePracticeMemberMutationOptions(options));
};

/**
 * @summary Accept a practice invitation by token
 */
export const getAcceptPracticeInviteUrl = (token: string) => {
  return `/api/practices/join/${token}`;
};

export const acceptPracticeInvite = async (
  token: string,
  options?: RequestInit,
): Promise<PracticeWithMembership> => {
  return customFetch<PracticeWithMembership>(
    getAcceptPracticeInviteUrl(token),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAcceptPracticeInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPracticeInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptPracticeInvite>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["acceptPracticeInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptPracticeInvite>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return acceptPracticeInvite(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptPracticeInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptPracticeInvite>>
>;

export type AcceptPracticeInviteMutationError = ErrorType<void>;

/**
 * @summary Accept a practice invitation by token
 */
export const useAcceptPracticeInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPracticeInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptPracticeInvite>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getAcceptPracticeInviteMutationOptions(options));
};

/**
 * @summary List all practices (admin only)
 */
export const getAdminListPracticesUrl = () => {
  return `/api/admin/practices`;
};

export const adminListPractices = async (
  options?: RequestInit,
): Promise<PracticeWithMemberCount[]> => {
  return customFetch<PracticeWithMemberCount[]>(getAdminListPracticesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListPracticesQueryKey = () => {
  return [`/api/admin/practices`] as const;
};

export const getAdminListPracticesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPractices>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPractices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListPracticesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListPractices>>
  > = ({ signal }) => adminListPractices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPractices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPracticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPractices>>
>;
export type AdminListPracticesQueryError = ErrorType<void>;

/**
 * @summary List all practices (admin only)
 */

export function useAdminListPractices<
  TData = Awaited<ReturnType<typeof adminListPractices>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPractices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPracticesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a clinician briefing assembled from the patient's record, active medications,
monitoring due dates, and any matching patient-portal advice queries. Scoped to the
caller's organisation.

Patient-portal requests are matched by name + date of birth AND restricted to the
caller's active practice (or NHS trust hospitals when no active practice is set)
so no other practice's submissions can be exposed.

The server also accepts an undocumented `audience=coordinator` query parameter that
returns a non-clinical view (diagnosis, clinical notes, medications, and request
body details stripped). This is an internal-only capability used by future
coordinator surfaces and is not part of the public contract yet — clients should
not depend on it.

 * @summary Aggregated pre-consultation summary for a single patient
 */
export const getGetPatientPreConsultSummaryUrl = (id: number) => {
  return `/api/med-tracker/patients/${id}/summary`;
};

export const getPatientPreConsultSummary = async (
  id: number,
  options?: RequestInit,
): Promise<PatientPreConsultSummary> => {
  return customFetch<PatientPreConsultSummary>(
    getGetPatientPreConsultSummaryUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPatientPreConsultSummaryQueryKey = (id: number) => {
  return [`/api/med-tracker/patients/${id}/summary`] as const;
};

export const getGetPatientPreConsultSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientPreConsultSummary>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPatientPreConsultSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientPreConsultSummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientPreConsultSummary>>
  > = ({ signal }) =>
    getPatientPreConsultSummary(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientPreConsultSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPatientPreConsultSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientPreConsultSummary>>
>;
export type GetPatientPreConsultSummaryQueryError = ErrorType<void>;

/**
 * @summary Aggregated pre-consultation summary for a single patient
 */

export function useGetPatientPreConsultSummary<
  TData = Awaited<ReturnType<typeof getPatientPreConsultSummary>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPatientPreConsultSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPatientPreConsultSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all user profiles (admin only), enriched with Clerk display name and email
 */
export const getAdminListUsersUrl = (params?: AdminListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/users?${stringifiedParams}`
    : `/api/admin/users`;
};

export const adminListUsers = async (
  params?: AdminListUsersParams,
  options?: RequestInit,
): Promise<AdminUserProfile[]> => {
  return customFetch<AdminUserProfile[]>(getAdminListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListUsersQueryKey = (params?: AdminListUsersParams) => {
  return [`/api/admin/users`, ...(params ? [params] : [])] as const;
};

export const getAdminListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<void>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUsers>>> = ({
    signal,
  }) => adminListUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUsers>>
>;
export type AdminListUsersQueryError = ErrorType<void>;

/**
 * @summary List all user profiles (admin only), enriched with Clerk display name and email
 */

export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<void>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve a user's pilot access (admin only). Sends approval email.
 */
export const getAdminApproveUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}/approve`;
};

export const adminApproveUser = async (
  userId: string,
  approvalActionInput?: ApprovalActionInput,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getAdminApproveUserUrl(userId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approvalActionInput),
  });
};

export const getAdminApproveUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApproveUser>>,
    TError,
    { userId: string; data: BodyType<ApprovalActionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminApproveUser>>,
  TError,
  { userId: string; data: BodyType<ApprovalActionInput> },
  TContext
> => {
  const mutationKey = ["adminApproveUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminApproveUser>>,
    { userId: string; data: BodyType<ApprovalActionInput> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminApproveUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminApproveUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminApproveUser>>
>;
export type AdminApproveUserMutationBody = BodyType<ApprovalActionInput>;
export type AdminApproveUserMutationError = ErrorType<void>;

/**
 * @summary Approve a user's pilot access (admin only). Sends approval email.
 */
export const useAdminApproveUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApproveUser>>,
    TError,
    { userId: string; data: BodyType<ApprovalActionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminApproveUser>>,
  TError,
  { userId: string; data: BodyType<ApprovalActionInput> },
  TContext
> => {
  return useMutation(getAdminApproveUserMutationOptions(options));
};

/**
 * @summary Reject a user's pilot access (admin only). Sends rejection email.
 */
export const getAdminRejectUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}/reject`;
};

export const adminRejectUser = async (
  userId: string,
  approvalActionInput?: ApprovalActionInput,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getAdminRejectUserUrl(userId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approvalActionInput),
  });
};

export const getAdminRejectUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectUser>>,
    TError,
    { userId: string; data: BodyType<ApprovalActionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRejectUser>>,
  TError,
  { userId: string; data: BodyType<ApprovalActionInput> },
  TContext
> => {
  const mutationKey = ["adminRejectUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRejectUser>>,
    { userId: string; data: BodyType<ApprovalActionInput> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminRejectUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRejectUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRejectUser>>
>;
export type AdminRejectUserMutationBody = BodyType<ApprovalActionInput>;
export type AdminRejectUserMutationError = ErrorType<void>;

/**
 * @summary Reject a user's pilot access (admin only). Sends rejection email.
 */
export const useAdminRejectUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectUser>>,
    TError,
    { userId: string; data: BodyType<ApprovalActionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRejectUser>>,
  TError,
  { userId: string; data: BodyType<ApprovalActionInput> },
  TContext
> => {
  return useMutation(getAdminRejectUserMutationOptions(options));
};

/**
 * @summary List all safety reports (admin only)
 */
export const getAdminListSafetyReportsUrl = (
  params?: AdminListSafetyReportsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/safety-reports?${stringifiedParams}`
    : `/api/admin/safety-reports`;
};

export const adminListSafetyReports = async (
  params?: AdminListSafetyReportsParams,
  options?: RequestInit,
): Promise<SafetyReport[]> => {
  return customFetch<SafetyReport[]>(getAdminListSafetyReportsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListSafetyReportsQueryKey = (
  params?: AdminListSafetyReportsParams,
) => {
  return [`/api/admin/safety-reports`, ...(params ? [params] : [])] as const;
};

export const getAdminListSafetyReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListSafetyReports>>,
  TError = ErrorType<void>,
>(
  params?: AdminListSafetyReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListSafetyReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListSafetyReportsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListSafetyReports>>
  > = ({ signal }) =>
    adminListSafetyReports(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListSafetyReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListSafetyReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListSafetyReports>>
>;
export type AdminListSafetyReportsQueryError = ErrorType<void>;

/**
 * @summary List all safety reports (admin only)
 */

export function useAdminListSafetyReports<
  TData = Awaited<ReturnType<typeof adminListSafetyReports>>,
  TError = ErrorType<void>,
>(
  params?: AdminListSafetyReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListSafetyReports>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListSafetyReportsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the status of a safety report (admin only)
 */
export const getAdminUpdateSafetyReportUrl = (id: number) => {
  return `/api/admin/safety-reports/${id}`;
};

export const adminUpdateSafetyReport = async (
  id: number,
  adminUpdateSafetyReportInput: AdminUpdateSafetyReportInput,
  options?: RequestInit,
): Promise<SafetyReport> => {
  return customFetch<SafetyReport>(getAdminUpdateSafetyReportUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminUpdateSafetyReportInput),
  });
};

export const getAdminUpdateSafetyReportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSafetyReport>>,
    TError,
    { id: number; data: BodyType<AdminUpdateSafetyReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateSafetyReport>>,
  TError,
  { id: number; data: BodyType<AdminUpdateSafetyReportInput> },
  TContext
> => {
  const mutationKey = ["adminUpdateSafetyReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateSafetyReport>>,
    { id: number; data: BodyType<AdminUpdateSafetyReportInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUpdateSafetyReport(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateSafetyReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateSafetyReport>>
>;
export type AdminUpdateSafetyReportMutationBody =
  BodyType<AdminUpdateSafetyReportInput>;
export type AdminUpdateSafetyReportMutationError = ErrorType<void>;

/**
 * @summary Update the status of a safety report (admin only)
 */
export const useAdminUpdateSafetyReport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSafetyReport>>,
    TError,
    { id: number; data: BodyType<AdminUpdateSafetyReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateSafetyReport>>,
  TError,
  { id: number; data: BodyType<AdminUpdateSafetyReportInput> },
  TContext
> => {
  return useMutation(getAdminUpdateSafetyReportMutationOptions(options));
};

/**
 * @summary List investigation notes for a safety report (admin only)
 */
export const getAdminListSafetyReportNotesUrl = (id: number) => {
  return `/api/admin/safety-reports/${id}/notes`;
};

export const adminListSafetyReportNotes = async (
  id: number,
  options?: RequestInit,
): Promise<SafetyReportNote[]> => {
  return customFetch<SafetyReportNote[]>(getAdminListSafetyReportNotesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminListSafetyReportNotesQueryKey = (id: number) => {
  return [`/api/admin/safety-reports/${id}/notes`] as const;
};

export const getAdminListSafetyReportNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListSafetyReportNotes>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListSafetyReportNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListSafetyReportNotesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListSafetyReportNotes>>
  > = ({ signal }) =>
    adminListSafetyReportNotes(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListSafetyReportNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListSafetyReportNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListSafetyReportNotes>>
>;
export type AdminListSafetyReportNotesQueryError = ErrorType<void>;

/**
 * @summary List investigation notes for a safety report (admin only)
 */

export function useAdminListSafetyReportNotes<
  TData = Awaited<ReturnType<typeof adminListSafetyReportNotes>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListSafetyReportNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListSafetyReportNotesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add an investigation note to a safety report (admin only)
 */
export const getAdminAddSafetyReportNoteUrl = (id: number) => {
  return `/api/admin/safety-reports/${id}/notes`;
};

export const adminAddSafetyReportNote = async (
  id: number,
  createSafetyReportNoteInput: CreateSafetyReportNoteInput,
  options?: RequestInit,
): Promise<SafetyReportNote> => {
  return customFetch<SafetyReportNote>(getAdminAddSafetyReportNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSafetyReportNoteInput),
  });
};

export const getAdminAddSafetyReportNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAddSafetyReportNote>>,
    TError,
    { id: number; data: BodyType<CreateSafetyReportNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminAddSafetyReportNote>>,
  TError,
  { id: number; data: BodyType<CreateSafetyReportNoteInput> },
  TContext
> => {
  const mutationKey = ["adminAddSafetyReportNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminAddSafetyReportNote>>,
    { id: number; data: BodyType<CreateSafetyReportNoteInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminAddSafetyReportNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAddSafetyReportNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminAddSafetyReportNote>>
>;
export type AdminAddSafetyReportNoteMutationBody =
  BodyType<CreateSafetyReportNoteInput>;
export type AdminAddSafetyReportNoteMutationError = ErrorType<void>;

/**
 * @summary Add an investigation note to a safety report (admin only)
 */
export const useAdminAddSafetyReportNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAddSafetyReportNote>>,
    TError,
    { id: number; data: BodyType<CreateSafetyReportNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminAddSafetyReportNote>>,
  TError,
  { id: number; data: BodyType<CreateSafetyReportNoteInput> },
  TContext
> => {
  return useMutation(getAdminAddSafetyReportNoteMutationOptions(options));
};

/**
 * @summary List patient invitations for the coordinator's active practice
 */
export const getListPatientInvitationsUrl = () => {
  return `/api/coordinator/invitations`;
};

export const listPatientInvitations = async (
  options?: RequestInit,
): Promise<PatientInvitation[]> => {
  return customFetch<PatientInvitation[]>(getListPatientInvitationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPatientInvitationsQueryKey = () => {
  return [`/api/coordinator/invitations`] as const;
};

export const getListPatientInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPatientInvitations>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPatientInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPatientInvitationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPatientInvitations>>
  > = ({ signal }) => listPatientInvitations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPatientInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPatientInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPatientInvitations>>
>;
export type ListPatientInvitationsQueryError = ErrorType<void>;

/**
 * @summary List patient invitations for the coordinator's active practice
 */

export function useListPatientInvitations<
  TData = Awaited<ReturnType<typeof listPatientInvitations>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPatientInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPatientInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Invite a named patient to join the practice
 */
export const getCreatePatientInvitationUrl = () => {
  return `/api/coordinator/invitations`;
};

export const createPatientInvitation = async (
  createPatientInvitationInput: CreatePatientInvitationInput,
  options?: RequestInit,
): Promise<CreatePatientInvitationResult> => {
  return customFetch<CreatePatientInvitationResult>(
    getCreatePatientInvitationUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createPatientInvitationInput),
    },
  );
};

export const getCreatePatientInvitationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPatientInvitation>>,
    TError,
    { data: BodyType<CreatePatientInvitationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPatientInvitation>>,
  TError,
  { data: BodyType<CreatePatientInvitationInput> },
  TContext
> => {
  const mutationKey = ["createPatientInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPatientInvitation>>,
    { data: BodyType<CreatePatientInvitationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createPatientInvitation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePatientInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPatientInvitation>>
>;
export type CreatePatientInvitationMutationBody =
  BodyType<CreatePatientInvitationInput>;
export type CreatePatientInvitationMutationError = ErrorType<void>;

/**
 * @summary Invite a named patient to join the practice
 */
export const useCreatePatientInvitation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPatientInvitation>>,
    TError,
    { data: BodyType<CreatePatientInvitationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPatientInvitation>>,
  TError,
  { data: BodyType<CreatePatientInvitationInput> },
  TContext
> => {
  return useMutation(getCreatePatientInvitationMutationOptions(options));
};

/**
 * @summary Cancel a pending or expired patient invitation
 */
export const getCancelPatientInvitationUrl = (id: number) => {
  return `/api/coordinator/invitations/${id}`;
};

export const cancelPatientInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<CancelPatientInvitation200> => {
  return customFetch<CancelPatientInvitation200>(
    getCancelPatientInvitationUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getCancelPatientInvitationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelPatientInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelPatientInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["cancelPatientInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelPatientInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cancelPatientInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelPatientInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelPatientInvitation>>
>;

export type CancelPatientInvitationMutationError = ErrorType<void>;

/**
 * @summary Cancel a pending or expired patient invitation
 */
export const useCancelPatientInvitation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelPatientInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelPatientInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCancelPatientInvitationMutationOptions(options));
};

/**
 * @summary Resend a patient invitation with a fresh 7-day token
 */
export const getResendPatientInvitationUrl = (id: number) => {
  return `/api/coordinator/invitations/${id}/resend`;
};

export const resendPatientInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<CreatePatientInvitationResult> => {
  return customFetch<CreatePatientInvitationResult>(
    getResendPatientInvitationUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResendPatientInvitationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendPatientInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendPatientInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resendPatientInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendPatientInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resendPatientInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendPatientInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendPatientInvitation>>
>;

export type ResendPatientInvitationMutationError = ErrorType<void>;

/**
 * @summary Resend a patient invitation with a fresh 7-day token
 */
export const useResendPatientInvitation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendPatientInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendPatientInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResendPatientInvitationMutationOptions(options));
};

/**
 * @summary Public preview of a patient invitation by token
 */
export const getGetPatientInvitationByTokenUrl = (token: string) => {
  return `/api/invitations/by-token/${token}`;
};

export const getPatientInvitationByToken = async (
  token: string,
  options?: RequestInit,
): Promise<PatientInvitationPreview> => {
  return customFetch<PatientInvitationPreview>(
    getGetPatientInvitationByTokenUrl(token),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPatientInvitationByTokenQueryKey = (token: string) => {
  return [`/api/invitations/by-token/${token}`] as const;
};

export const getGetPatientInvitationByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientInvitationByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPatientInvitationByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientInvitationByTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientInvitationByToken>>
  > = ({ signal }) =>
    getPatientInvitationByToken(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientInvitationByToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPatientInvitationByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientInvitationByToken>>
>;
export type GetPatientInvitationByTokenQueryError = ErrorType<void>;

/**
 * @summary Public preview of a patient invitation by token
 */

export function useGetPatientInvitationByToken<
  TData = Awaited<ReturnType<typeof getPatientInvitationByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPatientInvitationByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPatientInvitationByTokenQueryOptions(
    token,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Accept a patient invitation — links the signed-in user to the practice
 */
export const getAcceptPatientInvitationUrl = (token: string) => {
  return `/api/invitations/accept/${token}`;
};

export const acceptPatientInvitation = async (
  token: string,
  options?: RequestInit,
): Promise<AcceptPatientInvitationResult> => {
  return customFetch<AcceptPatientInvitationResult>(
    getAcceptPatientInvitationUrl(token),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAcceptPatientInvitationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPatientInvitation>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptPatientInvitation>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["acceptPatientInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptPatientInvitation>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return acceptPatientInvitation(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptPatientInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptPatientInvitation>>
>;

export type AcceptPatientInvitationMutationError = ErrorType<void>;

/**
 * @summary Accept a patient invitation — links the signed-in user to the practice
 */
export const useAcceptPatientInvitation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPatientInvitation>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptPatientInvitation>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getAcceptPatientInvitationMutationOptions(options));
};

/**
 * @summary Edit an investigation note (author only, admin only)
 */
export const getAdminUpdateSafetyReportNoteUrl = (
  id: number,
  noteId: number,
) => {
  return `/api/admin/safety-reports/${id}/notes/${noteId}`;
};

export const adminUpdateSafetyReportNote = async (
  id: number,
  noteId: number,
  updateSafetyReportNoteInput: UpdateSafetyReportNoteInput,
  options?: RequestInit,
): Promise<SafetyReportNote> => {
  return customFetch<SafetyReportNote>(
    getAdminUpdateSafetyReportNoteUrl(id, noteId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateSafetyReportNoteInput),
    },
  );
};

export const getAdminUpdateSafetyReportNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>,
    TError,
    { id: number; noteId: number; data: BodyType<UpdateSafetyReportNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>,
  TError,
  { id: number; noteId: number; data: BodyType<UpdateSafetyReportNoteInput> },
  TContext
> => {
  const mutationKey = ["adminUpdateSafetyReportNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>,
    { id: number; noteId: number; data: BodyType<UpdateSafetyReportNoteInput> }
  > = (props) => {
    const { id, noteId, data } = props ?? {};

    return adminUpdateSafetyReportNote(id, noteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateSafetyReportNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>
>;
export type AdminUpdateSafetyReportNoteMutationBody =
  BodyType<UpdateSafetyReportNoteInput>;
export type AdminUpdateSafetyReportNoteMutationError = ErrorType<void>;

/**
 * @summary Edit an investigation note (author only, admin only)
 */
export const useAdminUpdateSafetyReportNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>,
    TError,
    { id: number; noteId: number; data: BodyType<UpdateSafetyReportNoteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateSafetyReportNote>>,
  TError,
  { id: number; noteId: number; data: BodyType<UpdateSafetyReportNoteInput> },
  TContext
> => {
  return useMutation(getAdminUpdateSafetyReportNoteMutationOptions(options));
};

/**
 * @summary Delete an investigation note (author only, admin only)
 */
export const getAdminDeleteSafetyReportNoteUrl = (
  id: number,
  noteId: number,
) => {
  return `/api/admin/safety-reports/${id}/notes/${noteId}`;
};

export const adminDeleteSafetyReportNote = async (
  id: number,
  noteId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminDeleteSafetyReportNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminDeleteSafetyReportNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>,
    TError,
    { id: number; noteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>,
  TError,
  { id: number; noteId: number },
  TContext
> => {
  const mutationKey = ["adminDeleteSafetyReportNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>,
    { id: number; noteId: number }
  > = (props) => {
    const { id, noteId } = props ?? {};

    return adminDeleteSafetyReportNote(id, noteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteSafetyReportNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>
>;

export type AdminDeleteSafetyReportNoteMutationError = ErrorType<void>;

/**
 * @summary Delete an investigation note (author only, admin only)
 */
export const useAdminDeleteSafetyReportNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>,
    TError,
    { id: number; noteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteSafetyReportNote>>,
  TError,
  { id: number; noteId: number },
  TContext
> => {
  return useMutation(getAdminDeleteSafetyReportNoteMutationOptions(options));
};

/**
 * @summary List safety reports submitted by the current authenticated HCP
 */
export const getListMySafetyReportsUrl = () => {
  return `/api/hcp/safety-reports`;
};

export const listMySafetyReports = async (
  options?: RequestInit,
): Promise<SafetyReport[]> => {
  return customFetch<SafetyReport[]>(getListMySafetyReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMySafetyReportsQueryKey = () => {
  return [`/api/hcp/safety-reports`] as const;
};

export const getListMySafetyReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMySafetyReports>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMySafetyReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMySafetyReportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMySafetyReports>>
  > = ({ signal }) => listMySafetyReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMySafetyReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMySafetyReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMySafetyReports>>
>;
export type ListMySafetyReportsQueryError = ErrorType<void>;

/**
 * @summary List safety reports submitted by the current authenticated HCP
 */

export function useListMySafetyReports<
  TData = Awaited<ReturnType<typeof listMySafetyReports>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMySafetyReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMySafetyReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a safety concern or bug report (HCP only)
 */
export const getSubmitSafetyReportUrl = () => {
  return `/api/safety-reports`;
};

export const submitSafetyReport = async (
  submitSafetyReportInput: SubmitSafetyReportInput,
  options?: RequestInit,
): Promise<SafetyReport> => {
  return customFetch<SafetyReport>(getSubmitSafetyReportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitSafetyReportInput),
  });
};

export const getSubmitSafetyReportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitSafetyReport>>,
    TError,
    { data: BodyType<SubmitSafetyReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitSafetyReport>>,
  TError,
  { data: BodyType<SubmitSafetyReportInput> },
  TContext
> => {
  const mutationKey = ["submitSafetyReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitSafetyReport>>,
    { data: BodyType<SubmitSafetyReportInput> }
  > = (props) => {
    const { data } = props ?? {};

    return submitSafetyReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitSafetyReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitSafetyReport>>
>;
export type SubmitSafetyReportMutationBody = BodyType<SubmitSafetyReportInput>;
export type SubmitSafetyReportMutationError = ErrorType<void>;

/**
 * @summary Submit a safety concern or bug report (HCP only)
 */
export const useSubmitSafetyReport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitSafetyReport>>,
    TError,
    { data: BodyType<SubmitSafetyReportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitSafetyReport>>,
  TError,
  { data: BodyType<SubmitSafetyReportInput> },
  TContext
> => {
  return useMutation(getSubmitSafetyReportMutationOptions(options));
};

/**
 * @summary List all incoming patient requests (nurse view)
 */
export const getListIncomingPatientRequestsUrl = (
  params?: ListIncomingPatientRequestsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/nurse/patient-requests?${stringifiedParams}`
    : `/api/nurse/patient-requests`;
};

export const listIncomingPatientRequests = async (
  params?: ListIncomingPatientRequestsParams,
  options?: RequestInit,
): Promise<PatientRequest[]> => {
  return customFetch<PatientRequest[]>(
    getListIncomingPatientRequestsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListIncomingPatientRequestsQueryKey = (
  params?: ListIncomingPatientRequestsParams,
) => {
  return [`/api/nurse/patient-requests`, ...(params ? [params] : [])] as const;
};

export const getListIncomingPatientRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listIncomingPatientRequests>>,
  TError = ErrorType<void>,
>(
  params?: ListIncomingPatientRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listIncomingPatientRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListIncomingPatientRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listIncomingPatientRequests>>
  > = ({ signal }) =>
    listIncomingPatientRequests(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listIncomingPatientRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListIncomingPatientRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIncomingPatientRequests>>
>;
export type ListIncomingPatientRequestsQueryError = ErrorType<void>;

/**
 * @summary List all incoming patient requests (nurse view)
 */

export function useListIncomingPatientRequests<
  TData = Awaited<ReturnType<typeof listIncomingPatientRequests>>,
  TError = ErrorType<void>,
>(
  params?: ListIncomingPatientRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listIncomingPatientRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListIncomingPatientRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the current patient's submitted requests
 */
export const getListPatientRequestsUrl = () => {
  return `/api/patient/requests`;
};

export const listPatientRequests = async (
  options?: RequestInit,
): Promise<PatientRequest[]> => {
  return customFetch<PatientRequest[]>(getListPatientRequestsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPatientRequestsQueryKey = () => {
  return [`/api/patient/requests`] as const;
};

export const getListPatientRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPatientRequests>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPatientRequests>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPatientRequestsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPatientRequests>>
  > = ({ signal }) => listPatientRequests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPatientRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPatientRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPatientRequests>>
>;
export type ListPatientRequestsQueryError = ErrorType<void>;

/**
 * @summary List the current patient's submitted requests
 */

export function useListPatientRequests<
  TData = Awaited<ReturnType<typeof listPatientRequests>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPatientRequests>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPatientRequestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a prescription query or blood form request
 */
export const getSubmitPatientRequestUrl = () => {
  return `/api/patient/requests`;
};

export const submitPatientRequest = async (
  submitPatientRequestInput: SubmitPatientRequestInput,
  options?: RequestInit,
): Promise<PatientRequest> => {
  return customFetch<PatientRequest>(getSubmitPatientRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitPatientRequestInput),
  });
};

export const getSubmitPatientRequestMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitPatientRequest>>,
    TError,
    { data: BodyType<SubmitPatientRequestInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitPatientRequest>>,
  TError,
  { data: BodyType<SubmitPatientRequestInput> },
  TContext
> => {
  const mutationKey = ["submitPatientRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitPatientRequest>>,
    { data: BodyType<SubmitPatientRequestInput> }
  > = (props) => {
    const { data } = props ?? {};

    return submitPatientRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitPatientRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitPatientRequest>>
>;
export type SubmitPatientRequestMutationBody =
  BodyType<SubmitPatientRequestInput>;
export type SubmitPatientRequestMutationError = ErrorType<void>;

/**
 * @summary Submit a prescription query or blood form request
 */
export const useSubmitPatientRequest = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitPatientRequest>>,
    TError,
    { data: BodyType<SubmitPatientRequestInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitPatientRequest>>,
  TError,
  { data: BodyType<SubmitPatientRequestInput> },
  TContext
> => {
  return useMutation(getSubmitPatientRequestMutationOptions(options));
};

/**
 * @summary List NHS hospitals with rheumatology advice line contacts
 */
export const getListHospitalsUrl = (params?: ListHospitalsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/directory/hospitals?${stringifiedParams}`
    : `/api/directory/hospitals`;
};

export const listHospitals = async (
  params?: ListHospitalsParams,
  options?: RequestInit,
): Promise<Hospital[]> => {
  return customFetch<Hospital[]>(getListHospitalsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListHospitalsQueryKey = (params?: ListHospitalsParams) => {
  return [`/api/directory/hospitals`, ...(params ? [params] : [])] as const;
};

export const getListHospitalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHospitals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHospitalsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHospitals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHospitalsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHospitals>>> = ({
    signal,
  }) => listHospitals(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHospitals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHospitalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHospitals>>
>;
export type ListHospitalsQueryError = ErrorType<unknown>;

/**
 * @summary List NHS hospitals with rheumatology advice line contacts
 */

export function useListHospitals<
  TData = Awaited<ReturnType<typeof listHospitals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHospitalsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHospitals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListHospitalsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List homecare supply companies with regional contacts
 */
export const getListSupplyCompaniesUrl = (
  params?: ListSupplyCompaniesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/directory/supply-companies?${stringifiedParams}`
    : `/api/directory/supply-companies`;
};

export const listSupplyCompanies = async (
  params?: ListSupplyCompaniesParams,
  options?: RequestInit,
): Promise<SupplyCompany[]> => {
  return customFetch<SupplyCompany[]>(getListSupplyCompaniesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSupplyCompaniesQueryKey = (
  params?: ListSupplyCompaniesParams,
) => {
  return [
    `/api/directory/supply-companies`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSupplyCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSupplyCompanies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplyCompaniesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplyCompanies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSupplyCompaniesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSupplyCompanies>>
  > = ({ signal }) =>
    listSupplyCompanies(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSupplyCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSupplyCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSupplyCompanies>>
>;
export type ListSupplyCompaniesQueryError = ErrorType<unknown>;

/**
 * @summary List homecare supply companies with regional contacts
 */

export function useListSupplyCompanies<
  TData = Awaited<ReturnType<typeof listSupplyCompanies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplyCompaniesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplyCompanies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSupplyCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List UK rheumatology events
 */
export const getListEventsUrl = (params?: ListEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/events?${stringifiedParams}`
    : `/api/events`;
};

export const listEvents = async (
  params?: ListEventsParams,
  options?: RequestInit,
): Promise<Event[]> => {
  return customFetch<Event[]>(getListEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEventsQueryKey = (params?: ListEventsParams) => {
  return [`/api/events`, ...(params ? [params] : [])] as const;
};

export const getListEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({
    signal,
  }) => listEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvents>>
>;
export type ListEventsQueryError = ErrorType<unknown>;

/**
 * @summary List UK rheumatology events
 */

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List clinical guidelines
 */
export const getListGuidelinesUrl = (params?: ListGuidelinesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/guidelines?${stringifiedParams}`
    : `/api/guidelines`;
};

export const listGuidelines = async (
  params?: ListGuidelinesParams,
  options?: RequestInit,
): Promise<Guideline[]> => {
  return customFetch<Guideline[]>(getListGuidelinesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListGuidelinesQueryKey = (params?: ListGuidelinesParams) => {
  return [`/api/guidelines`, ...(params ? [params] : [])] as const;
};

export const getListGuidelinesQueryOptions = <
  TData = Awaited<ReturnType<typeof listGuidelines>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGuidelinesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGuidelines>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGuidelinesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGuidelines>>> = ({
    signal,
  }) => listGuidelines(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGuidelines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGuidelinesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGuidelines>>
>;
export type ListGuidelinesQueryError = ErrorType<unknown>;

/**
 * @summary List clinical guidelines
 */

export function useListGuidelines<
  TData = Awaited<ReturnType<typeof listGuidelines>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGuidelinesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGuidelines>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGuidelinesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a guideline by ID
 */
export const getGetGuidelineUrl = (id: number) => {
  return `/api/guidelines/${id}`;
};

export const getGuideline = async (
  id: number,
  options?: RequestInit,
): Promise<Guideline> => {
  return customFetch<Guideline>(getGetGuidelineUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGuidelineQueryKey = (id: number) => {
  return [`/api/guidelines/${id}`] as const;
};

export const getGetGuidelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getGuideline>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGuideline>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGuidelineQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuideline>>> = ({
    signal,
  }) => getGuideline(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGuideline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGuidelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGuideline>>
>;
export type GetGuidelineQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a guideline by ID
 */

export function useGetGuideline<
  TData = Awaited<ReturnType<typeof getGuideline>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGuideline>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGuidelineQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get counts by category and organisation
 */
export const getGetGuidelinesSummaryUrl = () => {
  return `/api/guidelines/summary`;
};

export const getGuidelinesSummary = async (
  options?: RequestInit,
): Promise<GuidelinesSummary> => {
  return customFetch<GuidelinesSummary>(getGetGuidelinesSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGuidelinesSummaryQueryKey = () => {
  return [`/api/guidelines/summary`] as const;
};

export const getGetGuidelinesSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getGuidelinesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGuidelinesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGuidelinesSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGuidelinesSummary>>
  > = ({ signal }) => getGuidelinesSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGuidelinesSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGuidelinesSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGuidelinesSummary>>
>;
export type GetGuidelinesSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get counts by category and organisation
 */

export function useGetGuidelinesSummary<
  TData = Awaited<ReturnType<typeof getGuidelinesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGuidelinesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGuidelinesSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List rheumatology conditions
 */
export const getListConditionsUrl = (params?: ListConditionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/conditions?${stringifiedParams}`
    : `/api/conditions`;
};

export const listConditions = async (
  params?: ListConditionsParams,
  options?: RequestInit,
): Promise<Condition[]> => {
  return customFetch<Condition[]>(getListConditionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListConditionsQueryKey = (params?: ListConditionsParams) => {
  return [`/api/conditions`, ...(params ? [params] : [])] as const;
};

export const getListConditionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listConditions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListConditionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listConditions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListConditionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listConditions>>> = ({
    signal,
  }) => listConditions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConditions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListConditionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listConditions>>
>;
export type ListConditionsQueryError = ErrorType<unknown>;

/**
 * @summary List rheumatology conditions
 */

export function useListConditions<
  TData = Awaited<ReturnType<typeof listConditions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListConditionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listConditions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListConditionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a condition by ID
 */
export const getGetConditionUrl = (id: number) => {
  return `/api/conditions/${id}`;
};

export const getCondition = async (
  id: number,
  options?: RequestInit,
): Promise<Condition> => {
  return customFetch<Condition>(getGetConditionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetConditionQueryKey = (id: number) => {
  return [`/api/conditions/${id}`] as const;
};

export const getGetConditionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCondition>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCondition>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConditionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCondition>>> = ({
    signal,
  }) => getCondition(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCondition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConditionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCondition>>
>;
export type GetConditionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a condition by ID
 */

export function useGetCondition<
  TData = Awaited<ReturnType<typeof getCondition>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCondition>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConditionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List rheumatology medications
 */
export const getListMedicationsUrl = (params?: ListMedicationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/medications?${stringifiedParams}`
    : `/api/medications`;
};

export const listMedications = async (
  params?: ListMedicationsParams,
  options?: RequestInit,
): Promise<Medication[]> => {
  return customFetch<Medication[]>(getListMedicationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMedicationsQueryKey = (params?: ListMedicationsParams) => {
  return [`/api/medications`, ...(params ? [params] : [])] as const;
};

export const getListMedicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMedications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMedicationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMedications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMedicationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMedications>>> = ({
    signal,
  }) => listMedications(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMedications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMedicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMedications>>
>;
export type ListMedicationsQueryError = ErrorType<unknown>;

/**
 * @summary List rheumatology medications
 */

export function useListMedications<
  TData = Awaited<ReturnType<typeof listMedications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMedicationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMedications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMedicationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a medication by ID
 */
export const getGetMedicationUrl = (id: number) => {
  return `/api/medications/${id}`;
};

export const getMedication = async (
  id: number,
  options?: RequestInit,
): Promise<Medication> => {
  return customFetch<Medication>(getGetMedicationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMedicationQueryKey = (id: number) => {
  return [`/api/medications/${id}`] as const;
};

export const getGetMedicationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedication>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedication>>> = ({
    signal,
  }) => getMedication(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedication>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMedicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedication>>
>;
export type GetMedicationQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a medication by ID
 */

export function useGetMedication<
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedication>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMedicationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Check drug interactions using RxNorm
 */
export const getCheckInteractionsUrl = (params: CheckInteractionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/interactions?${stringifiedParams}`
    : `/api/interactions`;
};

export const checkInteractions = async (
  params: CheckInteractionsParams,
  options?: RequestInit,
): Promise<InteractionResult> => {
  return customFetch<InteractionResult>(getCheckInteractionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCheckInteractionsQueryKey = (
  params?: CheckInteractionsParams,
) => {
  return [`/api/interactions`, ...(params ? [params] : [])] as const;
};

export const getCheckInteractionsQueryOptions = <
  TData = Awaited<ReturnType<typeof checkInteractions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: CheckInteractionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkInteractions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckInteractionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkInteractions>>
  > = ({ signal }) => checkInteractions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkInteractions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckInteractionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkInteractions>>
>;
export type CheckInteractionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Check drug interactions using RxNorm
 */

export function useCheckInteractions<
  TData = Awaited<ReturnType<typeof checkInteractions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: CheckInteractionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkInteractions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckInteractionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List nurse advice line and NMC mock scenarios
 */
export const getListScenariosUrl = (params?: ListScenariosParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/scenarios?${stringifiedParams}`
    : `/api/scenarios`;
};

export const listScenarios = async (
  params?: ListScenariosParams,
  options?: RequestInit,
): Promise<Scenario[]> => {
  return customFetch<Scenario[]>(getListScenariosUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListScenariosQueryKey = (params?: ListScenariosParams) => {
  return [`/api/scenarios`, ...(params ? [params] : [])] as const;
};

export const getListScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof listScenarios>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScenariosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScenarios>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScenariosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScenarios>>> = ({
    signal,
  }) => listScenarios(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListScenariosQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScenarios>>
>;
export type ListScenariosQueryError = ErrorType<unknown>;

/**
 * @summary List nurse advice line and NMC mock scenarios
 */

export function useListScenarios<
  TData = Awaited<ReturnType<typeof listScenarios>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScenariosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScenarios>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListScenariosQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a scenario by ID with full answer
 */
export const getGetScenarioUrl = (id: number) => {
  return `/api/scenarios/${id}`;
};

export const getScenario = async (
  id: number,
  options?: RequestInit,
): Promise<Scenario> => {
  return customFetch<Scenario>(getGetScenarioUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetScenarioQueryKey = (id: number) => {
  return [`/api/scenarios/${id}`] as const;
};

export const getGetScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof getScenario>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScenario>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScenarioQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScenario>>> = ({
    signal,
  }) => getScenario(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getScenario>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetScenarioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScenario>>
>;
export type GetScenarioQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a scenario by ID with full answer
 */

export function useGetScenario<
  TData = Awaited<ReturnType<typeof getScenario>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScenario>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetScenarioQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List patient resources and links
 */
export const getListResourcesUrl = (params?: ListResourcesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/resources?${stringifiedParams}`
    : `/api/resources`;
};

export const listResources = async (
  params?: ListResourcesParams,
  options?: RequestInit,
): Promise<Resource[]> => {
  return customFetch<Resource[]>(getListResourcesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListResourcesQueryKey = (params?: ListResourcesParams) => {
  return [`/api/resources`, ...(params ? [params] : [])] as const;
};

export const getListResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListResourcesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listResources>>> = ({
    signal,
  }) => listResources(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listResources>>
>;
export type ListResourcesQueryError = ErrorType<unknown>;

/**
 * @summary List patient resources and links
 */

export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListResourcesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get nurse dashboard summary stats
 */
export const getGetNurseDashboardUrl = () => {
  return `/api/dashboard/nurse`;
};

export const getNurseDashboard = async (
  options?: RequestInit,
): Promise<NurseDashboard> => {
  return customFetch<NurseDashboard>(getGetNurseDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNurseDashboardQueryKey = () => {
  return [`/api/dashboard/nurse`] as const;
};

export const getGetNurseDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getNurseDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNurseDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNurseDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNurseDashboard>>
  > = ({ signal }) => getNurseDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNurseDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNurseDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNurseDashboard>>
>;
export type GetNurseDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Get nurse dashboard summary stats
 */

export function useGetNurseDashboard<
  TData = Awaited<ReturnType<typeof getNurseDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNurseDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNurseDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get patient dashboard summary
 */
export const getGetPatientDashboardUrl = () => {
  return `/api/dashboard/patient`;
};

export const getPatientDashboard = async (
  options?: RequestInit,
): Promise<PatientDashboard> => {
  return customFetch<PatientDashboard>(getGetPatientDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPatientDashboardQueryKey = () => {
  return [`/api/dashboard/patient`] as const;
};

export const getGetPatientDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPatientDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientDashboard>>
  > = ({ signal }) => getPatientDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPatientDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientDashboard>>
>;
export type GetPatientDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Get patient dashboard summary
 */

export function useGetPatientDashboard<
  TData = Awaited<ReturnType<typeof getPatientDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPatientDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPatientDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all conversations
 */
export const getListOpenaiConversationsUrl = () => {
  return `/api/openai/conversations`;
};

export const listOpenaiConversations = async (
  options?: RequestInit,
): Promise<OpenaiConversation[]> => {
  return customFetch<OpenaiConversation[]>(getListOpenaiConversationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOpenaiConversationsQueryKey = () => {
  return [`/api/openai/conversations`] as const;
};

export const getListOpenaiConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOpenaiConversations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOpenaiConversations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOpenaiConversationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOpenaiConversations>>
  > = ({ signal }) => listOpenaiConversations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOpenaiConversations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOpenaiConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOpenaiConversations>>
>;
export type ListOpenaiConversationsQueryError = ErrorType<unknown>;

/**
 * @summary List all conversations
 */

export function useListOpenaiConversations<
  TData = Awaited<ReturnType<typeof listOpenaiConversations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOpenaiConversations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOpenaiConversationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new conversation
 */
export const getCreateOpenaiConversationUrl = () => {
  return `/api/openai/conversations`;
};

export const createOpenaiConversation = async (
  openaiConversationInput: OpenaiConversationInput,
  options?: RequestInit,
): Promise<OpenaiConversation> => {
  return customFetch<OpenaiConversation>(getCreateOpenaiConversationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(openaiConversationInput),
  });
};

export const getCreateOpenaiConversationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOpenaiConversation>>,
    TError,
    { data: BodyType<OpenaiConversationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOpenaiConversation>>,
  TError,
  { data: BodyType<OpenaiConversationInput> },
  TContext
> => {
  const mutationKey = ["createOpenaiConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOpenaiConversation>>,
    { data: BodyType<OpenaiConversationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createOpenaiConversation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOpenaiConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOpenaiConversation>>
>;
export type CreateOpenaiConversationMutationBody =
  BodyType<OpenaiConversationInput>;
export type CreateOpenaiConversationMutationError = ErrorType<unknown>;

/**
 * @summary Create a new conversation
 */
export const useCreateOpenaiConversation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOpenaiConversation>>,
    TError,
    { data: BodyType<OpenaiConversationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOpenaiConversation>>,
  TError,
  { data: BodyType<OpenaiConversationInput> },
  TContext
> => {
  return useMutation(getCreateOpenaiConversationMutationOptions(options));
};

/**
 * @summary Get conversation with messages
 */
export const getGetOpenaiConversationUrl = (id: number) => {
  return `/api/openai/conversations/${id}`;
};

export const getOpenaiConversation = async (
  id: number,
  options?: RequestInit,
): Promise<OpenaiConversationWithMessages> => {
  return customFetch<OpenaiConversationWithMessages>(
    getGetOpenaiConversationUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetOpenaiConversationQueryKey = (id: number) => {
  return [`/api/openai/conversations/${id}`] as const;
};

export const getGetOpenaiConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOpenaiConversation>>,
  TError = ErrorType<OpenaiError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpenaiConversation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOpenaiConversationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOpenaiConversation>>
  > = ({ signal }) => getOpenaiConversation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOpenaiConversation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOpenaiConversationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOpenaiConversation>>
>;
export type GetOpenaiConversationQueryError = ErrorType<OpenaiError>;

/**
 * @summary Get conversation with messages
 */

export function useGetOpenaiConversation<
  TData = Awaited<ReturnType<typeof getOpenaiConversation>>,
  TError = ErrorType<OpenaiError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpenaiConversation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOpenaiConversationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a conversation
 */
export const getDeleteOpenaiConversationUrl = (id: number) => {
  return `/api/openai/conversations/${id}`;
};

export const deleteOpenaiConversation = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteOpenaiConversationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOpenaiConversationMutationOptions = <
  TError = ErrorType<OpenaiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOpenaiConversation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOpenaiConversation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteOpenaiConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOpenaiConversation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOpenaiConversation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOpenaiConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOpenaiConversation>>
>;

export type DeleteOpenaiConversationMutationError = ErrorType<OpenaiError>;

/**
 * @summary Delete a conversation
 */
export const useDeleteOpenaiConversation = <
  TError = ErrorType<OpenaiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOpenaiConversation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOpenaiConversation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteOpenaiConversationMutationOptions(options));
};

/**
 * @summary List messages in a conversation
 */
export const getListOpenaiMessagesUrl = (id: number) => {
  return `/api/openai/conversations/${id}/messages`;
};

export const listOpenaiMessages = async (
  id: number,
  options?: RequestInit,
): Promise<OpenaiMessage[]> => {
  return customFetch<OpenaiMessage[]>(getListOpenaiMessagesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListOpenaiMessagesQueryKey = (id: number) => {
  return [`/api/openai/conversations/${id}/messages`] as const;
};

export const getListOpenaiMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOpenaiMessages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOpenaiMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOpenaiMessagesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOpenaiMessages>>
  > = ({ signal }) => listOpenaiMessages(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOpenaiMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOpenaiMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOpenaiMessages>>
>;
export type ListOpenaiMessagesQueryError = ErrorType<unknown>;

/**
 * @summary List messages in a conversation
 */

export function useListOpenaiMessages<
  TData = Awaited<ReturnType<typeof listOpenaiMessages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOpenaiMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOpenaiMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a text message and receive a streaming text response
 */
export const getSendOpenaiMessageUrl = (id: number) => {
  return `/api/openai/conversations/${id}/messages`;
};

export const sendOpenaiMessage = async (
  id: number,
  openaiMessageInput: OpenaiMessageInput,
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getSendOpenaiMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(openaiMessageInput),
  });
};

export const getSendOpenaiMessageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOpenaiMessage>>,
    TError,
    { id: number; data: BodyType<OpenaiMessageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOpenaiMessage>>,
  TError,
  { id: number; data: BodyType<OpenaiMessageInput> },
  TContext
> => {
  const mutationKey = ["sendOpenaiMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOpenaiMessage>>,
    { id: number; data: BodyType<OpenaiMessageInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendOpenaiMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendOpenaiMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendOpenaiMessage>>
>;
export type SendOpenaiMessageMutationBody = BodyType<OpenaiMessageInput>;
export type SendOpenaiMessageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a text message and receive a streaming text response
 */
export const useSendOpenaiMessage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOpenaiMessage>>,
    TError,
    { id: number; data: BodyType<OpenaiMessageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendOpenaiMessage>>,
  TError,
  { id: number; data: BodyType<OpenaiMessageInput> },
  TContext
> => {
  return useMutation(getSendOpenaiMessageMutationOptions(options));
};

/**
 * @summary Get summary of user's stored data
 */
export const getGetUserDataSummaryUrl = () => {
  return `/api/user/data/summary`;
};

export const getUserDataSummary = async (
  options?: RequestInit,
): Promise<UserDataSummary> => {
  return customFetch<UserDataSummary>(getGetUserDataSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUserDataSummaryQueryKey = () => {
  return [`/api/user/data/summary`] as const;
};

export const getGetUserDataSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDataSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDataSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserDataSummary>>
  > = ({ signal }) => getUserDataSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserDataSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserDataSummary>>
>;
export type GetUserDataSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get summary of user's stored data
 */

export function useGetUserDataSummary<
  TData = Awaited<ReturnType<typeof getUserDataSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserDataSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Export all user data as JSON (GDPR Subject Access Request)
 */
export const getGetUserDataExportUrl = () => {
  return `/api/user/data/export`;
};

export const getUserDataExport = async (
  options?: RequestInit,
): Promise<UserDataExport> => {
  return customFetch<UserDataExport>(getGetUserDataExportUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUserDataExportQueryKey = () => {
  return [`/api/user/data/export`] as const;
};

export const getGetUserDataExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDataExport>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataExport>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDataExportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserDataExport>>
  > = ({ signal }) => getUserDataExport({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserDataExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserDataExport>>
>;
export type GetUserDataExportQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Export all user data as JSON (GDPR Subject Access Request)
 */

export function useGetUserDataExport<
  TData = Awaited<ReturnType<typeof getUserDataExport>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserDataExport>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserDataExportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send an email-confirmation code that the user must enter before their
data is permanently deleted (UK GDPR erasure, patient flow).

 */
export const getRequestUserDataDeletionUrl = () => {
  return `/api/user/data/delete/request`;
};

export const requestUserDataDeletion = async (
  options?: RequestInit,
): Promise<RequestUserDataDeletionResult> => {
  return customFetch<RequestUserDataDeletionResult>(
    getRequestUserDataDeletionUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRequestUserDataDeletionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUserDataDeletion>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUserDataDeletion>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["requestUserDataDeletion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUserDataDeletion>>,
    void
  > = () => {
    return requestUserDataDeletion(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUserDataDeletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUserDataDeletion>>
>;

export type RequestUserDataDeletionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send an email-confirmation code that the user must enter before their
data is permanently deleted (UK GDPR erasure, patient flow).

 */
export const useRequestUserDataDeletion = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUserDataDeletion>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUserDataDeletion>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRequestUserDataDeletionMutationOptions(options));
};

/**
 * @summary Delete all user data (GDPR erasure right)
 */
export const getDeleteUserDataUrl = () => {
  return `/api/user/data`;
};

export const deleteUserData = async (
  deleteUserDataInput?: DeleteUserDataInput,
  options?: RequestInit,
): Promise<UserDataDeleteResult> => {
  return customFetch<UserDataDeleteResult>(getDeleteUserDataUrl(), {
    ...options,
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteUserDataInput),
  });
};

export const getDeleteUserDataMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserData>>,
    TError,
    { data: BodyType<DeleteUserDataInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserData>>,
  TError,
  { data: BodyType<DeleteUserDataInput> },
  TContext
> => {
  const mutationKey = ["deleteUserData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserData>>,
    { data: BodyType<DeleteUserDataInput> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteUserData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserData>>
>;
export type DeleteUserDataMutationBody = BodyType<DeleteUserDataInput>;
export type DeleteUserDataMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete all user data (GDPR erasure right)
 */
export const useDeleteUserData = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserData>>,
    TError,
    { data: BodyType<DeleteUserDataInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserData>>,
  TError,
  { data: BodyType<DeleteUserDataInput> },
  TContext
> => {
  return useMutation(getDeleteUserDataMutationOptions(options));
};

/**
 * @summary Get the authenticated patient's preferences (e.g. retention window)
 */
export const getGetUserPreferencesUrl = () => {
  return `/api/user/preferences`;
};

export const getUserPreferences = async (
  options?: RequestInit,
): Promise<UserPreferences> => {
  return customFetch<UserPreferences>(getGetUserPreferencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUserPreferencesQueryKey = () => {
  return [`/api/user/preferences`] as const;
};

export const getGetUserPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPreferences>>
  > = ({ signal }) => getUserPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPreferences>>
>;
export type GetUserPreferencesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the authenticated patient's preferences (e.g. retention window)
 */

export function useGetUserPreferences<
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the authenticated patient's preferences
 */
export const getUpdateUserPreferencesUrl = () => {
  return `/api/user/preferences`;
};

export const updateUserPreferences = async (
  updateUserPreferencesInput: UpdateUserPreferencesInput,
  options?: RequestInit,
): Promise<UserPreferences> => {
  return customFetch<UserPreferences>(getUpdateUserPreferencesUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserPreferencesInput),
  });
};

export const getUpdateUserPreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: BodyType<UpdateUserPreferencesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: BodyType<UpdateUserPreferencesInput> },
  TContext
> => {
  const mutationKey = ["updateUserPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    { data: BodyType<UpdateUserPreferencesInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateUserPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserPreferences>>
>;
export type UpdateUserPreferencesMutationBody =
  BodyType<UpdateUserPreferencesInput>;
export type UpdateUserPreferencesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the authenticated patient's preferences
 */
export const useUpdateUserPreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: BodyType<UpdateUserPreferencesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: BodyType<UpdateUserPreferencesInput> },
  TContext
> => {
  return useMutation(getUpdateUserPreferencesMutationOptions(options));
};

/**
 * @summary Persist the authenticated user's role (nurse, patient, doctor, or pharmacist) in the database
 */
export const getSetUserRoleUrl = () => {
  return `/api/user/role`;
};

export const setUserRole = async (
  setRoleInput: SetRoleInput,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getSetUserRoleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setRoleInput),
  });
};

export const getSetUserRoleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUserRole>>,
    TError,
    { data: BodyType<SetRoleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setUserRole>>,
  TError,
  { data: BodyType<SetRoleInput> },
  TContext
> => {
  const mutationKey = ["setUserRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setUserRole>>,
    { data: BodyType<SetRoleInput> }
  > = (props) => {
    const { data } = props ?? {};

    return setUserRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetUserRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof setUserRole>>
>;
export type SetUserRoleMutationBody = BodyType<SetRoleInput>;
export type SetUserRoleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Persist the authenticated user's role (nurse, patient, doctor, or pharmacist) in the database
 */
export const useSetUserRole = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUserRole>>,
    TError,
    { data: BodyType<SetRoleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setUserRole>>,
  TError,
  { data: BodyType<SetRoleInput> },
  TContext
> => {
  return useMutation(getSetUserRoleMutationOptions(options));
};

/**
 * @summary List all RCN competency domains with statement counts (nurse-only)
 */
export const getListCompetencyDomainsUrl = () => {
  return `/api/competency/domains`;
};

export const listCompetencyDomains = async (
  options?: RequestInit,
): Promise<CompetencyDomain[]> => {
  return customFetch<CompetencyDomain[]>(getListCompetencyDomainsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCompetencyDomainsQueryKey = () => {
  return [`/api/competency/domains`] as const;
};

export const getListCompetencyDomainsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompetencyDomains>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCompetencyDomains>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCompetencyDomainsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCompetencyDomains>>
  > = ({ signal }) => listCompetencyDomains({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompetencyDomains>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCompetencyDomainsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompetencyDomains>>
>;
export type ListCompetencyDomainsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all RCN competency domains with statement counts (nurse-only)
 */

export function useListCompetencyDomains<
  TData = Awaited<ReturnType<typeof listCompetencyDomains>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCompetencyDomains>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCompetencyDomainsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List competency statements for a domain, with the nurse's portfolio entry status (nurse-only)
 */
export const getListCompetencyStatementsUrl = (id: number) => {
  return `/api/competency/domains/${id}/statements`;
};

export const listCompetencyStatements = async (
  id: number,
  options?: RequestInit,
): Promise<CompetencyStatementWithEntry[]> => {
  return customFetch<CompetencyStatementWithEntry[]>(
    getListCompetencyStatementsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCompetencyStatementsQueryKey = (id: number) => {
  return [`/api/competency/domains/${id}/statements`] as const;
};

export const getListCompetencyStatementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompetencyStatements>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompetencyStatements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCompetencyStatementsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCompetencyStatements>>
  > = ({ signal }) =>
    listCompetencyStatements(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompetencyStatements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCompetencyStatementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompetencyStatements>>
>;
export type ListCompetencyStatementsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List competency statements for a domain, with the nurse's portfolio entry status (nurse-only)
 */

export function useListCompetencyStatements<
  TData = Awaited<ReturnType<typeof listCompetencyStatements>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompetencyStatements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCompetencyStatementsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Full portfolio summary for the authenticated nurse (progress per domain)
 */
export const getGetPortfolioSummaryUrl = (
  params?: GetPortfolioSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/competency/portfolio?${stringifiedParams}`
    : `/api/competency/portfolio`;
};

export const getPortfolioSummary = async (
  params?: GetPortfolioSummaryParams,
  options?: RequestInit,
): Promise<PortfolioDomainSummary[]> => {
  return customFetch<PortfolioDomainSummary[]>(
    getGetPortfolioSummaryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPortfolioSummaryQueryKey = (
  params?: GetPortfolioSummaryParams,
) => {
  return [`/api/competency/portfolio`, ...(params ? [params] : [])] as const;
};

export const getGetPortfolioSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPortfolioSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPortfolioSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPortfolioSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPortfolioSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPortfolioSummary>>
  > = ({ signal }) =>
    getPortfolioSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPortfolioSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPortfolioSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPortfolioSummary>>
>;
export type GetPortfolioSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Full portfolio summary for the authenticated nurse (progress per domain)
 */

export function useGetPortfolioSummary<
  TData = Awaited<ReturnType<typeof getPortfolioSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPortfolioSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPortfolioSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPortfolioSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Full portfolio export payload (all domains, statements, entries, evidence metadata) for client-side PDF rendering
 */
export const getExportPortfolioUrl = () => {
  return `/api/competency/portfolio/export`;
};

export const exportPortfolio = async (
  options?: RequestInit,
): Promise<PortfolioExport> => {
  return customFetch<PortfolioExport>(getExportPortfolioUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportPortfolioQueryKey = () => {
  return [`/api/competency/portfolio/export`] as const;
};

export const getExportPortfolioQueryOptions = <
  TData = Awaited<ReturnType<typeof exportPortfolio>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolio>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportPortfolioQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPortfolio>>> = ({
    signal,
  }) => exportPortfolio({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportPortfolioQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportPortfolio>>
>;
export type ExportPortfolioQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Full portfolio export payload (all domains, statements, entries, evidence metadata) for client-side PDF rendering
 */

export function useExportPortfolio<
  TData = Awaited<ReturnType<typeof exportPortfolio>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolio>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportPortfolioQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Single portfolio entry with evidence list for a statement
 */
export const getGetPortfolioEntryUrl = (statementId: number) => {
  return `/api/competency/portfolio/${statementId}`;
};

export const getPortfolioEntry = async (
  statementId: number,
  options?: RequestInit,
): Promise<PortfolioEntryDetail> => {
  return customFetch<PortfolioEntryDetail>(
    getGetPortfolioEntryUrl(statementId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPortfolioEntryQueryKey = (statementId: number) => {
  return [`/api/competency/portfolio/${statementId}`] as const;
};

export const getGetPortfolioEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPortfolioEntry>>,
  TError = ErrorType<ErrorResponse>,
>(
  statementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPortfolioEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPortfolioEntryQueryKey(statementId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPortfolioEntry>>
  > = ({ signal }) =>
    getPortfolioEntry(statementId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!statementId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPortfolioEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPortfolioEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPortfolioEntry>>
>;
export type GetPortfolioEntryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Single portfolio entry with evidence list for a statement
 */

export function useGetPortfolioEntry<
  TData = Awaited<ReturnType<typeof getPortfolioEntry>>,
  TError = ErrorType<ErrorResponse>,
>(
  statementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPortfolioEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPortfolioEntryQueryOptions(statementId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update a portfolio entry (reflection, status, practice level)
 */
export const getUpsertPortfolioEntryUrl = (statementId: number) => {
  return `/api/competency/portfolio/${statementId}`;
};

export const upsertPortfolioEntry = async (
  statementId: number,
  portfolioEntryInput: PortfolioEntryInput,
  options?: RequestInit,
): Promise<PortfolioEntry> => {
  return customFetch<PortfolioEntry>(getUpsertPortfolioEntryUrl(statementId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(portfolioEntryInput),
  });
};

export const getUpsertPortfolioEntryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPortfolioEntry>>,
    TError,
    { statementId: number; data: BodyType<PortfolioEntryInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPortfolioEntry>>,
  TError,
  { statementId: number; data: BodyType<PortfolioEntryInput> },
  TContext
> => {
  const mutationKey = ["upsertPortfolioEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPortfolioEntry>>,
    { statementId: number; data: BodyType<PortfolioEntryInput> }
  > = (props) => {
    const { statementId, data } = props ?? {};

    return upsertPortfolioEntry(statementId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPortfolioEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPortfolioEntry>>
>;
export type UpsertPortfolioEntryMutationBody = BodyType<PortfolioEntryInput>;
export type UpsertPortfolioEntryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create or update a portfolio entry (reflection, status, practice level)
 */
export const useUpsertPortfolioEntry = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPortfolioEntry>>,
    TError,
    { statementId: number; data: BodyType<PortfolioEntryInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertPortfolioEntry>>,
  TError,
  { statementId: number; data: BodyType<PortfolioEntryInput> },
  TContext
> => {
  return useMutation(getUpsertPortfolioEntryMutationOptions(options));
};

/**
 * @summary Upload an evidence file and attach it to a portfolio entry
 */
export const getAddPortfolioEvidenceUrl = (statementId: number) => {
  return `/api/competency/portfolio/${statementId}/evidence`;
};

export const addPortfolioEvidence = async (
  statementId: number,
  evidenceUploadForm: EvidenceUploadForm,
  options?: RequestInit,
): Promise<PortfolioEvidence> => {
  const formData = new FormData();
  formData.append(`file`, evidenceUploadForm.file);

  return customFetch<PortfolioEvidence>(
    getAddPortfolioEvidenceUrl(statementId),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getAddPortfolioEvidenceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPortfolioEvidence>>,
    TError,
    { statementId: number; data: BodyType<EvidenceUploadForm> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPortfolioEvidence>>,
  TError,
  { statementId: number; data: BodyType<EvidenceUploadForm> },
  TContext
> => {
  const mutationKey = ["addPortfolioEvidence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPortfolioEvidence>>,
    { statementId: number; data: BodyType<EvidenceUploadForm> }
  > = (props) => {
    const { statementId, data } = props ?? {};

    return addPortfolioEvidence(statementId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPortfolioEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPortfolioEvidence>>
>;
export type AddPortfolioEvidenceMutationBody = BodyType<EvidenceUploadForm>;
export type AddPortfolioEvidenceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload an evidence file and attach it to a portfolio entry
 */
export const useAddPortfolioEvidence = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPortfolioEvidence>>,
    TError,
    { statementId: number; data: BodyType<EvidenceUploadForm> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addPortfolioEvidence>>,
  TError,
  { statementId: number; data: BodyType<EvidenceUploadForm> },
  TContext
> => {
  return useMutation(getAddPortfolioEvidenceMutationOptions(options));
};

/**
 * @summary Download an evidence file
 */
export const getDownloadPortfolioEvidenceUrl = (
  statementId: number,
  evidenceId: number,
) => {
  return `/api/competency/portfolio/${statementId}/evidence/${evidenceId}/download`;
};

export const downloadPortfolioEvidence = async (
  statementId: number,
  evidenceId: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(
    getDownloadPortfolioEvidenceUrl(statementId, evidenceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDownloadPortfolioEvidenceQueryKey = (
  statementId: number,
  evidenceId: number,
) => {
  return [
    `/api/competency/portfolio/${statementId}/evidence/${evidenceId}/download`,
  ] as const;
};

export const getDownloadPortfolioEvidenceQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadPortfolioEvidence>>,
  TError = ErrorType<ErrorResponse>,
>(
  statementId: number,
  evidenceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadPortfolioEvidence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadPortfolioEvidenceQueryKey(statementId, evidenceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadPortfolioEvidence>>
  > = ({ signal }) =>
    downloadPortfolioEvidence(statementId, evidenceId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(statementId && evidenceId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadPortfolioEvidence>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadPortfolioEvidenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadPortfolioEvidence>>
>;
export type DownloadPortfolioEvidenceQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download an evidence file
 */

export function useDownloadPortfolioEvidence<
  TData = Awaited<ReturnType<typeof downloadPortfolioEvidence>>,
  TError = ErrorType<ErrorResponse>,
>(
  statementId: number,
  evidenceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadPortfolioEvidence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadPortfolioEvidenceQueryOptions(
    statementId,
    evidenceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete an evidence file from storage and DB
 */
export const getDeletePortfolioEvidenceUrl = (
  statementId: number,
  evidenceId: number,
) => {
  return `/api/competency/portfolio/${statementId}/evidence/${evidenceId}`;
};

export const deletePortfolioEvidence = async (
  statementId: number,
  evidenceId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeletePortfolioEvidenceUrl(statementId, evidenceId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeletePortfolioEvidenceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePortfolioEvidence>>,
    TError,
    { statementId: number; evidenceId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePortfolioEvidence>>,
  TError,
  { statementId: number; evidenceId: number },
  TContext
> => {
  const mutationKey = ["deletePortfolioEvidence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePortfolioEvidence>>,
    { statementId: number; evidenceId: number }
  > = (props) => {
    const { statementId, evidenceId } = props ?? {};

    return deletePortfolioEvidence(statementId, evidenceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePortfolioEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePortfolioEvidence>>
>;

export type DeletePortfolioEvidenceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete an evidence file from storage and DB
 */
export const useDeletePortfolioEvidence = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePortfolioEvidence>>,
    TError,
    { statementId: number; evidenceId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePortfolioEvidence>>,
  TError,
  { statementId: number; evidenceId: number },
  TContext
> => {
  return useMutation(getDeletePortfolioEvidenceMutationOptions(options));
};

/**
 * @summary Full portfolio export payload suitable for client-side PDF rendering (canonical path)
 */
export const getExportPortfolioPdfDataUrl = () => {
  return `/api/competency/export/pdf-data`;
};

export const exportPortfolioPdfData = async (
  options?: RequestInit,
): Promise<PortfolioExport> => {
  return customFetch<PortfolioExport>(getExportPortfolioPdfDataUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportPortfolioPdfDataQueryKey = () => {
  return [`/api/competency/export/pdf-data`] as const;
};

export const getExportPortfolioPdfDataQueryOptions = <
  TData = Awaited<ReturnType<typeof exportPortfolioPdfData>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolioPdfData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportPortfolioPdfDataQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportPortfolioPdfData>>
  > = ({ signal }) => exportPortfolioPdfData({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolioPdfData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportPortfolioPdfDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportPortfolioPdfData>>
>;
export type ExportPortfolioPdfDataQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Full portfolio export payload suitable for client-side PDF rendering (canonical path)
 */

export function useExportPortfolioPdfData<
  TData = Awaited<ReturnType<typeof exportPortfolioPdfData>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportPortfolioPdfData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportPortfolioPdfDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get CPD credit totals by category and overall for the current year
 */
export const getGetDoctorCpdSummaryUrl = () => {
  return `/api/doctor/cpd/summary`;
};

export const getDoctorCpdSummary = async (
  options?: RequestInit,
): Promise<DoctorCpdSummary> => {
  return customFetch<DoctorCpdSummary>(getGetDoctorCpdSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDoctorCpdSummaryQueryKey = () => {
  return [`/api/doctor/cpd/summary`] as const;
};

export const getGetDoctorCpdSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDoctorCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDoctorCpdSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDoctorCpdSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDoctorCpdSummary>>
  > = ({ signal }) => getDoctorCpdSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDoctorCpdSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDoctorCpdSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDoctorCpdSummary>>
>;
export type GetDoctorCpdSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get CPD credit totals by category and overall for the current year
 */

export function useGetDoctorCpdSummary<
  TData = Awaited<ReturnType<typeof getDoctorCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDoctorCpdSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDoctorCpdSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List CPD activities for the authenticated doctor
 */
export const getListDoctorCpdActivitiesUrl = (
  params?: ListDoctorCpdActivitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/doctor/cpd?${stringifiedParams}`
    : `/api/doctor/cpd`;
};

export const listDoctorCpdActivities = async (
  params?: ListDoctorCpdActivitiesParams,
  options?: RequestInit,
): Promise<DoctorCpdActivity[]> => {
  return customFetch<DoctorCpdActivity[]>(
    getListDoctorCpdActivitiesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListDoctorCpdActivitiesQueryKey = (
  params?: ListDoctorCpdActivitiesParams,
) => {
  return [`/api/doctor/cpd`, ...(params ? [params] : [])] as const;
};

export const getListDoctorCpdActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDoctorCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListDoctorCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDoctorCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDoctorCpdActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDoctorCpdActivities>>
  > = ({ signal }) =>
    listDoctorCpdActivities(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDoctorCpdActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDoctorCpdActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDoctorCpdActivities>>
>;
export type ListDoctorCpdActivitiesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List CPD activities for the authenticated doctor
 */

export function useListDoctorCpdActivities<
  TData = Awaited<ReturnType<typeof listDoctorCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListDoctorCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDoctorCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDoctorCpdActivitiesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a CPD activity
 */
export const getCreateDoctorCpdActivityUrl = () => {
  return `/api/doctor/cpd`;
};

export const createDoctorCpdActivity = async (
  doctorCpdActivityInput: DoctorCpdActivityInput,
  options?: RequestInit,
): Promise<DoctorCpdActivity> => {
  return customFetch<DoctorCpdActivity>(getCreateDoctorCpdActivityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(doctorCpdActivityInput),
  });
};

export const getCreateDoctorCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDoctorCpdActivity>>,
    TError,
    { data: BodyType<DoctorCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDoctorCpdActivity>>,
  TError,
  { data: BodyType<DoctorCpdActivityInput> },
  TContext
> => {
  const mutationKey = ["createDoctorCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDoctorCpdActivity>>,
    { data: BodyType<DoctorCpdActivityInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createDoctorCpdActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDoctorCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDoctorCpdActivity>>
>;
export type CreateDoctorCpdActivityMutationBody =
  BodyType<DoctorCpdActivityInput>;
export type CreateDoctorCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a CPD activity
 */
export const useCreateDoctorCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDoctorCpdActivity>>,
    TError,
    { data: BodyType<DoctorCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDoctorCpdActivity>>,
  TError,
  { data: BodyType<DoctorCpdActivityInput> },
  TContext
> => {
  return useMutation(getCreateDoctorCpdActivityMutationOptions(options));
};

/**
 * @summary Delete a CPD activity
 */
export const getDeleteDoctorCpdActivityUrl = (id: number) => {
  return `/api/doctor/cpd/${id}`;
};

export const deleteDoctorCpdActivity = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteDoctorCpdActivityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDoctorCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDoctorCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDoctorCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDoctorCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDoctorCpdActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDoctorCpdActivity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDoctorCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDoctorCpdActivity>>
>;

export type DeleteDoctorCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a CPD activity
 */
export const useDeleteDoctorCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDoctorCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDoctorCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteDoctorCpdActivityMutationOptions(options));
};

/**
 * @summary Export the authenticated doctor's full CPD portfolio as a GMC appraisal-ready PDF
 */
export const getExportDoctorCpdPortfolioPdfUrl = () => {
  return `/api/doctor/cpd/export.pdf`;
};

export const exportDoctorCpdPortfolioPdf = async (
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getExportDoctorCpdPortfolioPdfUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportDoctorCpdPortfolioPdfQueryKey = () => {
  return [`/api/doctor/cpd/export.pdf`] as const;
};

export const getExportDoctorCpdPortfolioPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportDoctorCpdPortfolioPdfQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>
  > = ({ signal }) =>
    exportDoctorCpdPortfolioPdf({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportDoctorCpdPortfolioPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>
>;
export type ExportDoctorCpdPortfolioPdfQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Export the authenticated doctor's full CPD portfolio as a GMC appraisal-ready PDF
 */

export function useExportDoctorCpdPortfolioPdf<
  TData = Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportDoctorCpdPortfolioPdf>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportDoctorCpdPortfolioPdfQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all curriculum entries for the authenticated doctor
 */
export const getListDoctorCurriculumEntriesUrl = () => {
  return `/api/doctor/curriculum`;
};

export const listDoctorCurriculumEntries = async (
  options?: RequestInit,
): Promise<DoctorCurriculumEntry[]> => {
  return customFetch<DoctorCurriculumEntry[]>(
    getListDoctorCurriculumEntriesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListDoctorCurriculumEntriesQueryKey = () => {
  return [`/api/doctor/curriculum`] as const;
};

export const getListDoctorCurriculumEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDoctorCurriculumEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDoctorCurriculumEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDoctorCurriculumEntriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDoctorCurriculumEntries>>
  > = ({ signal }) =>
    listDoctorCurriculumEntries({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDoctorCurriculumEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDoctorCurriculumEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDoctorCurriculumEntries>>
>;
export type ListDoctorCurriculumEntriesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all curriculum entries for the authenticated doctor
 */

export function useListDoctorCurriculumEntries<
  TData = Awaited<ReturnType<typeof listDoctorCurriculumEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDoctorCurriculumEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDoctorCurriculumEntriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert a curriculum competency entry
 */
export const getUpsertDoctorCurriculumEntryUrl = (
  domainKey: string,
  competencyKey: string,
) => {
  return `/api/doctor/curriculum/${domainKey}/${competencyKey}`;
};

export const upsertDoctorCurriculumEntry = async (
  domainKey: string,
  competencyKey: string,
  doctorCurriculumEntryInput: DoctorCurriculumEntryInput,
  options?: RequestInit,
): Promise<DoctorCurriculumEntry> => {
  return customFetch<DoctorCurriculumEntry>(
    getUpsertDoctorCurriculumEntryUrl(domainKey, competencyKey),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(doctorCurriculumEntryInput),
    },
  );
};

export const getUpsertDoctorCurriculumEntryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>,
    TError,
    {
      domainKey: string;
      competencyKey: string;
      data: BodyType<DoctorCurriculumEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>,
  TError,
  {
    domainKey: string;
    competencyKey: string;
    data: BodyType<DoctorCurriculumEntryInput>;
  },
  TContext
> => {
  const mutationKey = ["upsertDoctorCurriculumEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>,
    {
      domainKey: string;
      competencyKey: string;
      data: BodyType<DoctorCurriculumEntryInput>;
    }
  > = (props) => {
    const { domainKey, competencyKey, data } = props ?? {};

    return upsertDoctorCurriculumEntry(
      domainKey,
      competencyKey,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertDoctorCurriculumEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>
>;
export type UpsertDoctorCurriculumEntryMutationBody =
  BodyType<DoctorCurriculumEntryInput>;
export type UpsertDoctorCurriculumEntryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upsert a curriculum competency entry
 */
export const useUpsertDoctorCurriculumEntry = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>,
    TError,
    {
      domainKey: string;
      competencyKey: string;
      data: BodyType<DoctorCurriculumEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertDoctorCurriculumEntry>>,
  TError,
  {
    domainKey: string;
    competencyKey: string;
    data: BodyType<DoctorCurriculumEntryInput>;
  },
  TContext
> => {
  return useMutation(getUpsertDoctorCurriculumEntryMutationOptions(options));
};

/**
 * @summary List pharmacist patient counselling checklists (optionally filtered by drug)
 */
export const getListPharmacistCounsellingChecklistsUrl = (
  params?: ListPharmacistCounsellingChecklistsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/pharmacist/counselling-checklists?${stringifiedParams}`
    : `/api/pharmacist/counselling-checklists`;
};

export const listPharmacistCounsellingChecklists = async (
  params?: ListPharmacistCounsellingChecklistsParams,
  options?: RequestInit,
): Promise<PharmacistCounsellingChecklist[]> => {
  return customFetch<PharmacistCounsellingChecklist[]>(
    getListPharmacistCounsellingChecklistsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPharmacistCounsellingChecklistsQueryKey = (
  params?: ListPharmacistCounsellingChecklistsParams,
) => {
  return [
    `/api/pharmacist/counselling-checklists`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPharmacistCounsellingChecklistsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPharmacistCounsellingChecklistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPharmacistCounsellingChecklistsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>
  > = ({ signal }) =>
    listPharmacistCounsellingChecklists(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPharmacistCounsellingChecklistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>
>;
export type ListPharmacistCounsellingChecklistsQueryError =
  ErrorType<ErrorResponse>;

/**
 * @summary List pharmacist patient counselling checklists (optionally filtered by drug)
 */

export function useListPharmacistCounsellingChecklists<
  TData = Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPharmacistCounsellingChecklistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPharmacistCounsellingChecklists>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPharmacistCounsellingChecklistsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get CPD entry counts by type for a given year (defaults to current year)
 */
export const getGetPharmacistCpdSummaryUrl = (
  params?: GetPharmacistCpdSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/pharmacist/cpd/summary?${stringifiedParams}`
    : `/api/pharmacist/cpd/summary`;
};

export const getPharmacistCpdSummary = async (
  params?: GetPharmacistCpdSummaryParams,
  options?: RequestInit,
): Promise<PharmacistCpdSummary> => {
  return customFetch<PharmacistCpdSummary>(
    getGetPharmacistCpdSummaryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPharmacistCpdSummaryQueryKey = (
  params?: GetPharmacistCpdSummaryParams,
) => {
  return [`/api/pharmacist/cpd/summary`, ...(params ? [params] : [])] as const;
};

export const getGetPharmacistCpdSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPharmacistCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPharmacistCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPharmacistCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPharmacistCpdSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPharmacistCpdSummary>>
  > = ({ signal }) =>
    getPharmacistCpdSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPharmacistCpdSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPharmacistCpdSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPharmacistCpdSummary>>
>;
export type GetPharmacistCpdSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get CPD entry counts by type for a given year (defaults to current year)
 */

export function useGetPharmacistCpdSummary<
  TData = Awaited<ReturnType<typeof getPharmacistCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPharmacistCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPharmacistCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPharmacistCpdSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List CPD activities for the authenticated pharmacist
 */
export const getListPharmacistCpdActivitiesUrl = (
  params?: ListPharmacistCpdActivitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/pharmacist/cpd?${stringifiedParams}`
    : `/api/pharmacist/cpd`;
};

export const listPharmacistCpdActivities = async (
  params?: ListPharmacistCpdActivitiesParams,
  options?: RequestInit,
): Promise<PharmacistCpdActivity[]> => {
  return customFetch<PharmacistCpdActivity[]>(
    getListPharmacistCpdActivitiesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPharmacistCpdActivitiesQueryKey = (
  params?: ListPharmacistCpdActivitiesParams,
) => {
  return [`/api/pharmacist/cpd`, ...(params ? [params] : [])] as const;
};

export const getListPharmacistCpdActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPharmacistCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPharmacistCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPharmacistCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPharmacistCpdActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPharmacistCpdActivities>>
  > = ({ signal }) =>
    listPharmacistCpdActivities(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPharmacistCpdActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPharmacistCpdActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPharmacistCpdActivities>>
>;
export type ListPharmacistCpdActivitiesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List CPD activities for the authenticated pharmacist
 */

export function useListPharmacistCpdActivities<
  TData = Awaited<ReturnType<typeof listPharmacistCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPharmacistCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPharmacistCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPharmacistCpdActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a CPD activity
 */
export const getCreatePharmacistCpdActivityUrl = () => {
  return `/api/pharmacist/cpd`;
};

export const createPharmacistCpdActivity = async (
  pharmacistCpdActivityInput: PharmacistCpdActivityInput,
  options?: RequestInit,
): Promise<PharmacistCpdActivity> => {
  return customFetch<PharmacistCpdActivity>(
    getCreatePharmacistCpdActivityUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(pharmacistCpdActivityInput),
    },
  );
};

export const getCreatePharmacistCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPharmacistCpdActivity>>,
    TError,
    { data: BodyType<PharmacistCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPharmacistCpdActivity>>,
  TError,
  { data: BodyType<PharmacistCpdActivityInput> },
  TContext
> => {
  const mutationKey = ["createPharmacistCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPharmacistCpdActivity>>,
    { data: BodyType<PharmacistCpdActivityInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createPharmacistCpdActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePharmacistCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPharmacistCpdActivity>>
>;
export type CreatePharmacistCpdActivityMutationBody =
  BodyType<PharmacistCpdActivityInput>;
export type CreatePharmacistCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a CPD activity
 */
export const useCreatePharmacistCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPharmacistCpdActivity>>,
    TError,
    { data: BodyType<PharmacistCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPharmacistCpdActivity>>,
  TError,
  { data: BodyType<PharmacistCpdActivityInput> },
  TContext
> => {
  return useMutation(getCreatePharmacistCpdActivityMutationOptions(options));
};

/**
 * @summary Delete a CPD activity
 */
export const getDeletePharmacistCpdActivityUrl = (id: number) => {
  return `/api/pharmacist/cpd/${id}`;
};

export const deletePharmacistCpdActivity = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePharmacistCpdActivityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePharmacistCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePharmacistCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePharmacistCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePharmacistCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePharmacistCpdActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePharmacistCpdActivity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePharmacistCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePharmacistCpdActivity>>
>;

export type DeletePharmacistCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a CPD activity
 */
export const useDeletePharmacistCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePharmacistCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePharmacistCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePharmacistCpdActivityMutationOptions(options));
};

/**
 * @summary List all portfolio entries for the authenticated pharmacist
 */
export const getListPharmacistPortfolioEntriesUrl = () => {
  return `/api/pharmacist/portfolio`;
};

export const listPharmacistPortfolioEntries = async (
  options?: RequestInit,
): Promise<PharmacistPortfolioEntry[]> => {
  return customFetch<PharmacistPortfolioEntry[]>(
    getListPharmacistPortfolioEntriesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPharmacistPortfolioEntriesQueryKey = () => {
  return [`/api/pharmacist/portfolio`] as const;
};

export const getListPharmacistPortfolioEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPharmacistPortfolioEntriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>
  > = ({ signal }) =>
    listPharmacistPortfolioEntries({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPharmacistPortfolioEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>
>;
export type ListPharmacistPortfolioEntriesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all portfolio entries for the authenticated pharmacist
 */

export function useListPharmacistPortfolioEntries<
  TData = Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPharmacistPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPharmacistPortfolioEntriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert a pharmacist portfolio competency entry
 */
export const getUpsertPharmacistPortfolioEntryUrl = (
  frameworkKey: string,
  domainKey: string,
  competencyKey: string,
) => {
  return `/api/pharmacist/portfolio/${frameworkKey}/${domainKey}/${competencyKey}`;
};

export const upsertPharmacistPortfolioEntry = async (
  frameworkKey: string,
  domainKey: string,
  competencyKey: string,
  pharmacistPortfolioEntryInput: PharmacistPortfolioEntryInput,
  options?: RequestInit,
): Promise<PharmacistPortfolioEntry> => {
  return customFetch<PharmacistPortfolioEntry>(
    getUpsertPharmacistPortfolioEntryUrl(
      frameworkKey,
      domainKey,
      competencyKey,
    ),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(pharmacistPortfolioEntryInput),
    },
  );
};

export const getUpsertPharmacistPortfolioEntryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      domainKey: string;
      competencyKey: string;
      data: BodyType<PharmacistPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    domainKey: string;
    competencyKey: string;
    data: BodyType<PharmacistPortfolioEntryInput>;
  },
  TContext
> => {
  const mutationKey = ["upsertPharmacistPortfolioEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>,
    {
      frameworkKey: string;
      domainKey: string;
      competencyKey: string;
      data: BodyType<PharmacistPortfolioEntryInput>;
    }
  > = (props) => {
    const { frameworkKey, domainKey, competencyKey, data } = props ?? {};

    return upsertPharmacistPortfolioEntry(
      frameworkKey,
      domainKey,
      competencyKey,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPharmacistPortfolioEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>
>;
export type UpsertPharmacistPortfolioEntryMutationBody =
  BodyType<PharmacistPortfolioEntryInput>;
export type UpsertPharmacistPortfolioEntryMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Upsert a pharmacist portfolio competency entry
 */
export const useUpsertPharmacistPortfolioEntry = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      domainKey: string;
      competencyKey: string;
      data: BodyType<PharmacistPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertPharmacistPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    domainKey: string;
    competencyKey: string;
    data: BodyType<PharmacistPortfolioEntryInput>;
  },
  TContext
> => {
  return useMutation(getUpsertPharmacistPortfolioEntryMutationOptions(options));
};

/**
 * @summary Get CPD totals by category for the authenticated physio (defaults to current year)
 */
export const getGetPhysioCpdSummaryUrl = (
  params?: GetPhysioCpdSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/physio/cpd/summary?${stringifiedParams}`
    : `/api/physio/cpd/summary`;
};

export const getPhysioCpdSummary = async (
  params?: GetPhysioCpdSummaryParams,
  options?: RequestInit,
): Promise<PhysioCpdSummary> => {
  return customFetch<PhysioCpdSummary>(getGetPhysioCpdSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPhysioCpdSummaryQueryKey = (
  params?: GetPhysioCpdSummaryParams,
) => {
  return [`/api/physio/cpd/summary`, ...(params ? [params] : [])] as const;
};

export const getGetPhysioCpdSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhysioCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPhysioCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPhysioCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhysioCpdSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhysioCpdSummary>>
  > = ({ signal }) =>
    getPhysioCpdSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhysioCpdSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPhysioCpdSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhysioCpdSummary>>
>;
export type GetPhysioCpdSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get CPD totals by category for the authenticated physio (defaults to current year)
 */

export function useGetPhysioCpdSummary<
  TData = Awaited<ReturnType<typeof getPhysioCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPhysioCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPhysioCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPhysioCpdSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List CPD activities for the authenticated physio
 */
export const getListPhysioCpdActivitiesUrl = (
  params?: ListPhysioCpdActivitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/physio/cpd?${stringifiedParams}`
    : `/api/physio/cpd`;
};

export const listPhysioCpdActivities = async (
  params?: ListPhysioCpdActivitiesParams,
  options?: RequestInit,
): Promise<PhysioCpdActivity[]> => {
  return customFetch<PhysioCpdActivity[]>(
    getListPhysioCpdActivitiesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPhysioCpdActivitiesQueryKey = (
  params?: ListPhysioCpdActivitiesParams,
) => {
  return [`/api/physio/cpd`, ...(params ? [params] : [])] as const;
};

export const getListPhysioCpdActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPhysioCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPhysioCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPhysioCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPhysioCpdActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPhysioCpdActivities>>
  > = ({ signal }) =>
    listPhysioCpdActivities(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPhysioCpdActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPhysioCpdActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPhysioCpdActivities>>
>;
export type ListPhysioCpdActivitiesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List CPD activities for the authenticated physio
 */

export function useListPhysioCpdActivities<
  TData = Awaited<ReturnType<typeof listPhysioCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListPhysioCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPhysioCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPhysioCpdActivitiesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log a new CPD activity
 */
export const getCreatePhysioCpdActivityUrl = () => {
  return `/api/physio/cpd`;
};

export const createPhysioCpdActivity = async (
  physioCpdActivityInput: PhysioCpdActivityInput,
  options?: RequestInit,
): Promise<PhysioCpdActivity> => {
  return customFetch<PhysioCpdActivity>(getCreatePhysioCpdActivityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(physioCpdActivityInput),
  });
};

export const getCreatePhysioCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhysioCpdActivity>>,
    TError,
    { data: BodyType<PhysioCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhysioCpdActivity>>,
  TError,
  { data: BodyType<PhysioCpdActivityInput> },
  TContext
> => {
  const mutationKey = ["createPhysioCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhysioCpdActivity>>,
    { data: BodyType<PhysioCpdActivityInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createPhysioCpdActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePhysioCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhysioCpdActivity>>
>;
export type CreatePhysioCpdActivityMutationBody =
  BodyType<PhysioCpdActivityInput>;
export type CreatePhysioCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Log a new CPD activity
 */
export const useCreatePhysioCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhysioCpdActivity>>,
    TError,
    { data: BodyType<PhysioCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPhysioCpdActivity>>,
  TError,
  { data: BodyType<PhysioCpdActivityInput> },
  TContext
> => {
  return useMutation(getCreatePhysioCpdActivityMutationOptions(options));
};

/**
 * @summary Delete a CPD activity
 */
export const getDeletePhysioCpdActivityUrl = (id: number) => {
  return `/api/physio/cpd/${id}`;
};

export const deletePhysioCpdActivity = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePhysioCpdActivityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePhysioCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhysioCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhysioCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePhysioCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhysioCpdActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePhysioCpdActivity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePhysioCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhysioCpdActivity>>
>;

export type DeletePhysioCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a CPD activity
 */
export const useDeletePhysioCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhysioCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePhysioCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePhysioCpdActivityMutationOptions(options));
};

/**
 * @summary List all portfolio entries for the authenticated physio
 */
export const getListPhysioPortfolioEntriesUrl = () => {
  return `/api/physio/portfolio`;
};

export const listPhysioPortfolioEntries = async (
  options?: RequestInit,
): Promise<PhysioPortfolioEntry[]> => {
  return customFetch<PhysioPortfolioEntry[]>(
    getListPhysioPortfolioEntriesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPhysioPortfolioEntriesQueryKey = () => {
  return [`/api/physio/portfolio`] as const;
};

export const getListPhysioPortfolioEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPhysioPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPhysioPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPhysioPortfolioEntriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPhysioPortfolioEntries>>
  > = ({ signal }) => listPhysioPortfolioEntries({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPhysioPortfolioEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPhysioPortfolioEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPhysioPortfolioEntries>>
>;
export type ListPhysioPortfolioEntriesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all portfolio entries for the authenticated physio
 */

export function useListPhysioPortfolioEntries<
  TData = Awaited<ReturnType<typeof listPhysioPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPhysioPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPhysioPortfolioEntriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert a physio portfolio entry
 */
export const getUpsertPhysioPortfolioEntryUrl = (
  frameworkKey: string,
  pillarKey: string,
  competencyKey: string,
) => {
  return `/api/physio/portfolio/${frameworkKey}/${pillarKey}/${competencyKey}`;
};

export const upsertPhysioPortfolioEntry = async (
  frameworkKey: string,
  pillarKey: string,
  competencyKey: string,
  physioPortfolioEntryInput: PhysioPortfolioEntryInput,
  options?: RequestInit,
): Promise<PhysioPortfolioEntry> => {
  return customFetch<PhysioPortfolioEntry>(
    getUpsertPhysioPortfolioEntryUrl(frameworkKey, pillarKey, competencyKey),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(physioPortfolioEntryInput),
    },
  );
};

export const getUpsertPhysioPortfolioEntryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      pillarKey: string;
      competencyKey: string;
      data: BodyType<PhysioPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    pillarKey: string;
    competencyKey: string;
    data: BodyType<PhysioPortfolioEntryInput>;
  },
  TContext
> => {
  const mutationKey = ["upsertPhysioPortfolioEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>,
    {
      frameworkKey: string;
      pillarKey: string;
      competencyKey: string;
      data: BodyType<PhysioPortfolioEntryInput>;
    }
  > = (props) => {
    const { frameworkKey, pillarKey, competencyKey, data } = props ?? {};

    return upsertPhysioPortfolioEntry(
      frameworkKey,
      pillarKey,
      competencyKey,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPhysioPortfolioEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>
>;
export type UpsertPhysioPortfolioEntryMutationBody =
  BodyType<PhysioPortfolioEntryInput>;
export type UpsertPhysioPortfolioEntryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upsert a physio portfolio entry
 */
export const useUpsertPhysioPortfolioEntry = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      pillarKey: string;
      competencyKey: string;
      data: BodyType<PhysioPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertPhysioPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    pillarKey: string;
    competencyKey: string;
    data: BodyType<PhysioPortfolioEntryInput>;
  },
  TContext
> => {
  return useMutation(getUpsertPhysioPortfolioEntryMutationOptions(options));
};

/**
 * @summary Get CPD totals by category for the authenticated OT (defaults to current year)
 */
export const getGetOtCpdSummaryUrl = (params?: GetOtCpdSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ot/cpd/summary?${stringifiedParams}`
    : `/api/ot/cpd/summary`;
};

export const getOtCpdSummary = async (
  params?: GetOtCpdSummaryParams,
  options?: RequestInit,
): Promise<OtCpdSummary> => {
  return customFetch<OtCpdSummary>(getGetOtCpdSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOtCpdSummaryQueryKey = (params?: GetOtCpdSummaryParams) => {
  return [`/api/ot/cpd/summary`, ...(params ? [params] : [])] as const;
};

export const getGetOtCpdSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getOtCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetOtCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOtCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOtCpdSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtCpdSummary>>> = ({
    signal,
  }) => getOtCpdSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOtCpdSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOtCpdSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOtCpdSummary>>
>;
export type GetOtCpdSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get CPD totals by category for the authenticated OT (defaults to current year)
 */

export function useGetOtCpdSummary<
  TData = Awaited<ReturnType<typeof getOtCpdSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetOtCpdSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOtCpdSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOtCpdSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List CPD activities for the authenticated OT
 */
export const getListOtCpdActivitiesUrl = (
  params?: ListOtCpdActivitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ot/cpd?${stringifiedParams}`
    : `/api/ot/cpd`;
};

export const listOtCpdActivities = async (
  params?: ListOtCpdActivitiesParams,
  options?: RequestInit,
): Promise<OtCpdActivity[]> => {
  return customFetch<OtCpdActivity[]>(getListOtCpdActivitiesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListOtCpdActivitiesQueryKey = (
  params?: ListOtCpdActivitiesParams,
) => {
  return [`/api/ot/cpd`, ...(params ? [params] : [])] as const;
};

export const getListOtCpdActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOtCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListOtCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOtCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOtCpdActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOtCpdActivities>>
  > = ({ signal }) =>
    listOtCpdActivities(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOtCpdActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOtCpdActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOtCpdActivities>>
>;
export type ListOtCpdActivitiesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List CPD activities for the authenticated OT
 */

export function useListOtCpdActivities<
  TData = Awaited<ReturnType<typeof listOtCpdActivities>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListOtCpdActivitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOtCpdActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOtCpdActivitiesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log a new CPD activity
 */
export const getCreateOtCpdActivityUrl = () => {
  return `/api/ot/cpd`;
};

export const createOtCpdActivity = async (
  otCpdActivityInput: OtCpdActivityInput,
  options?: RequestInit,
): Promise<OtCpdActivity> => {
  return customFetch<OtCpdActivity>(getCreateOtCpdActivityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(otCpdActivityInput),
  });
};

export const getCreateOtCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtCpdActivity>>,
    TError,
    { data: BodyType<OtCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOtCpdActivity>>,
  TError,
  { data: BodyType<OtCpdActivityInput> },
  TContext
> => {
  const mutationKey = ["createOtCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOtCpdActivity>>,
    { data: BodyType<OtCpdActivityInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createOtCpdActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOtCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOtCpdActivity>>
>;
export type CreateOtCpdActivityMutationBody = BodyType<OtCpdActivityInput>;
export type CreateOtCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Log a new CPD activity
 */
export const useCreateOtCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtCpdActivity>>,
    TError,
    { data: BodyType<OtCpdActivityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOtCpdActivity>>,
  TError,
  { data: BodyType<OtCpdActivityInput> },
  TContext
> => {
  return useMutation(getCreateOtCpdActivityMutationOptions(options));
};

/**
 * @summary Delete a CPD activity
 */
export const getDeleteOtCpdActivityUrl = (id: number) => {
  return `/api/ot/cpd/${id}`;
};

export const deleteOtCpdActivity = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteOtCpdActivityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOtCpdActivityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOtCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOtCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteOtCpdActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOtCpdActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOtCpdActivity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOtCpdActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOtCpdActivity>>
>;

export type DeleteOtCpdActivityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a CPD activity
 */
export const useDeleteOtCpdActivity = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOtCpdActivity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOtCpdActivity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteOtCpdActivityMutationOptions(options));
};

/**
 * @summary List all portfolio entries for the authenticated OT
 */
export const getListOtPortfolioEntriesUrl = () => {
  return `/api/ot/portfolio`;
};

export const listOtPortfolioEntries = async (
  options?: RequestInit,
): Promise<OtPortfolioEntry[]> => {
  return customFetch<OtPortfolioEntry[]>(getListOtPortfolioEntriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOtPortfolioEntriesQueryKey = () => {
  return [`/api/ot/portfolio`] as const;
};

export const getListOtPortfolioEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOtPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOtPortfolioEntriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOtPortfolioEntries>>
  > = ({ signal }) => listOtPortfolioEntries({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOtPortfolioEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOtPortfolioEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOtPortfolioEntries>>
>;
export type ListOtPortfolioEntriesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all portfolio entries for the authenticated OT
 */

export function useListOtPortfolioEntries<
  TData = Awaited<ReturnType<typeof listOtPortfolioEntries>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtPortfolioEntries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOtPortfolioEntriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert an OT portfolio entry
 */
export const getUpsertOtPortfolioEntryUrl = (
  frameworkKey: string,
  stageKey: string,
  competencyKey: string,
) => {
  return `/api/ot/portfolio/${frameworkKey}/${stageKey}/${competencyKey}`;
};

export const upsertOtPortfolioEntry = async (
  frameworkKey: string,
  stageKey: string,
  competencyKey: string,
  otPortfolioEntryInput: OtPortfolioEntryInput,
  options?: RequestInit,
): Promise<OtPortfolioEntry> => {
  return customFetch<OtPortfolioEntry>(
    getUpsertOtPortfolioEntryUrl(frameworkKey, stageKey, competencyKey),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(otPortfolioEntryInput),
    },
  );
};

export const getUpsertOtPortfolioEntryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertOtPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      stageKey: string;
      competencyKey: string;
      data: BodyType<OtPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertOtPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    stageKey: string;
    competencyKey: string;
    data: BodyType<OtPortfolioEntryInput>;
  },
  TContext
> => {
  const mutationKey = ["upsertOtPortfolioEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertOtPortfolioEntry>>,
    {
      frameworkKey: string;
      stageKey: string;
      competencyKey: string;
      data: BodyType<OtPortfolioEntryInput>;
    }
  > = (props) => {
    const { frameworkKey, stageKey, competencyKey, data } = props ?? {};

    return upsertOtPortfolioEntry(
      frameworkKey,
      stageKey,
      competencyKey,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertOtPortfolioEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertOtPortfolioEntry>>
>;
export type UpsertOtPortfolioEntryMutationBody =
  BodyType<OtPortfolioEntryInput>;
export type UpsertOtPortfolioEntryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upsert an OT portfolio entry
 */
export const useUpsertOtPortfolioEntry = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertOtPortfolioEntry>>,
    TError,
    {
      frameworkKey: string;
      stageKey: string;
      competencyKey: string;
      data: BodyType<OtPortfolioEntryInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertOtPortfolioEntry>>,
  TError,
  {
    frameworkKey: string;
    stageKey: string;
    competencyKey: string;
    data: BodyType<OtPortfolioEntryInput>;
  },
  TContext
> => {
  return useMutation(getUpsertOtPortfolioEntryMutationOptions(options));
};

/**
 * @summary List all structured reflections for the authenticated OT
 */
export const getListOtReflectionsUrl = () => {
  return `/api/ot/reflections`;
};

export const listOtReflections = async (
  options?: RequestInit,
): Promise<OtReflection[]> => {
  return customFetch<OtReflection[]>(getListOtReflectionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOtReflectionsQueryKey = () => {
  return [`/api/ot/reflections`] as const;
};

export const getListOtReflectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOtReflections>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtReflections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOtReflectionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOtReflections>>
  > = ({ signal }) => listOtReflections({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOtReflections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOtReflectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOtReflections>>
>;
export type ListOtReflectionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all structured reflections for the authenticated OT
 */

export function useListOtReflections<
  TData = Awaited<ReturnType<typeof listOtReflections>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtReflections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOtReflectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new structured reflection entry
 */
export const getCreateOtReflectionUrl = () => {
  return `/api/ot/reflections`;
};

export const createOtReflection = async (
  otReflectionInput: OtReflectionInput,
  options?: RequestInit,
): Promise<OtReflection> => {
  return customFetch<OtReflection>(getCreateOtReflectionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(otReflectionInput),
  });
};

export const getCreateOtReflectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtReflection>>,
    TError,
    { data: BodyType<OtReflectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOtReflection>>,
  TError,
  { data: BodyType<OtReflectionInput> },
  TContext
> => {
  const mutationKey = ["createOtReflection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOtReflection>>,
    { data: BodyType<OtReflectionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createOtReflection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOtReflectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOtReflection>>
>;
export type CreateOtReflectionMutationBody = BodyType<OtReflectionInput>;
export type CreateOtReflectionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new structured reflection entry
 */
export const useCreateOtReflection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtReflection>>,
    TError,
    { data: BodyType<OtReflectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOtReflection>>,
  TError,
  { data: BodyType<OtReflectionInput> },
  TContext
> => {
  return useMutation(getCreateOtReflectionMutationOptions(options));
};

/**
 * @summary Delete a structured reflection entry
 */
export const getDeleteOtReflectionUrl = (id: number) => {
  return `/api/ot/reflections/${id}`;
};

export const deleteOtReflection = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteOtReflectionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOtReflectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOtReflection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOtReflection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteOtReflection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOtReflection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOtReflection(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOtReflectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOtReflection>>
>;

export type DeleteOtReflectionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a structured reflection entry
 */
export const useDeleteOtReflection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOtReflection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOtReflection>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteOtReflectionMutationOptions(options));
};

/**
 * @summary Get OT settings (HCPC renewal date)
 */
export const getGetOtSettingsUrl = () => {
  return `/api/ot/settings`;
};

export const getOtSettings = async (
  options?: RequestInit,
): Promise<OtSettings> => {
  return customFetch<OtSettings>(getGetOtSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOtSettingsQueryKey = () => {
  return [`/api/ot/settings`] as const;
};

export const getGetOtSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOtSettings>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOtSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOtSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtSettings>>> = ({
    signal,
  }) => getOtSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOtSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOtSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOtSettings>>
>;
export type GetOtSettingsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get OT settings (HCPC renewal date)
 */

export function useGetOtSettings<
  TData = Awaited<ReturnType<typeof getOtSettings>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOtSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOtSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update OT settings
 */
export const getUpdateOtSettingsUrl = () => {
  return `/api/ot/settings`;
};

export const updateOtSettings = async (
  otSettingsInput: OtSettingsInput,
  options?: RequestInit,
): Promise<OtSettings> => {
  return customFetch<OtSettings>(getUpdateOtSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(otSettingsInput),
  });
};

export const getUpdateOtSettingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOtSettings>>,
    TError,
    { data: BodyType<OtSettingsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOtSettings>>,
  TError,
  { data: BodyType<OtSettingsInput> },
  TContext
> => {
  const mutationKey = ["updateOtSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOtSettings>>,
    { data: BodyType<OtSettingsInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateOtSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOtSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOtSettings>>
>;
export type UpdateOtSettingsMutationBody = BodyType<OtSettingsInput>;
export type UpdateOtSettingsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update OT settings
 */
export const useUpdateOtSettings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOtSettings>>,
    TError,
    { data: BodyType<OtSettingsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOtSettings>>,
  TError,
  { data: BodyType<OtSettingsInput> },
  TContext
> => {
  return useMutation(getUpdateOtSettingsMutationOptions(options));
};

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<OpenaiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<OpenaiError>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<OpenaiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * Must be called after a direct PUT to the signed URL. Verifies that the actual object size and content type in storage match what was declared when the signed URL was requested. Marks the pending token as consumed on success. If constraints are violated the object is deleted.

 * @summary Confirm a direct upload and validate it against declared constraints
 */
export const getConfirmUploadUrl = () => {
  return `/api/storage/uploads/confirm`;
};

export const confirmUpload = async (
  confirmUploadRequest: ConfirmUploadRequest,
  options?: RequestInit,
): Promise<ConfirmUploadResult> => {
  return customFetch<ConfirmUploadResult>(getConfirmUploadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(confirmUploadRequest),
  });
};

export const getConfirmUploadMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmUpload>>,
    TError,
    { data: BodyType<ConfirmUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  { data: BodyType<ConfirmUploadRequest> },
  TContext
> => {
  const mutationKey = ["confirmUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmUpload>>,
    { data: BodyType<ConfirmUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return confirmUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmUpload>>
>;
export type ConfirmUploadMutationBody = BodyType<ConfirmUploadRequest>;
export type ConfirmUploadMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Confirm a direct upload and validate it against declared constraints
 */
export const useConfirmUpload = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmUpload>>,
    TError,
    { data: BodyType<ConfirmUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  { data: BodyType<ConfirmUploadRequest> },
  TContext
> => {
  return useMutation(getConfirmUploadMutationOptions(options));
};

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<OpenaiError>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<OpenaiError>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<OpenaiError>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Search NHS ODS organisations by name
 */
export const getSearchOrganisationsUrl = (
  params: SearchOrganisationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/organisations?${stringifiedParams}`
    : `/api/organisations`;
};

export const searchOrganisations = async (
  params: SearchOrganisationsParams,
  options?: RequestInit,
): Promise<OdsOrganisation[]> => {
  return customFetch<OdsOrganisation[]>(getSearchOrganisationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchOrganisationsQueryKey = (
  params?: SearchOrganisationsParams,
) => {
  return [`/api/organisations`, ...(params ? [params] : [])] as const;
};

export const getSearchOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchOrganisations>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: SearchOrganisationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchOrganisations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchOrganisationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchOrganisations>>
  > = ({ signal }) =>
    searchOrganisations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchOrganisations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchOrganisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchOrganisations>>
>;
export type SearchOrganisationsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Search NHS ODS organisations by name
 */

export function useSearchOrganisations<
  TData = Awaited<ReturnType<typeof searchOrganisations>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: SearchOrganisationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchOrganisations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchOrganisationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get child sites for an NHS ODS organisation (trust)
 */
export const getGetOrganisationSitesUrl = (odsCode: string) => {
  return `/api/organisations/${odsCode}/sites`;
};

export const getOrganisationSites = async (
  odsCode: string,
  options?: RequestInit,
): Promise<OdsOrganisation[]> => {
  return customFetch<OdsOrganisation[]>(getGetOrganisationSitesUrl(odsCode), {
    ...options,
    method: "GET",
  });
};

export const getGetOrganisationSitesQueryKey = (odsCode: string) => {
  return [`/api/organisations/${odsCode}/sites`] as const;
};

export const getGetOrganisationSitesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisationSites>>,
  TError = ErrorType<ErrorResponse>,
>(
  odsCode: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrganisationSites>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganisationSitesQueryKey(odsCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganisationSites>>
  > = ({ signal }) =>
    getOrganisationSites(odsCode, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!odsCode,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationSites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganisationSitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisationSites>>
>;
export type GetOrganisationSitesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get child sites for an NHS ODS organisation (trust)
 */

export function useGetOrganisationSites<
  TData = Awaited<ReturnType<typeof getOrganisationSites>>,
  TError = ErrorType<ErrorResponse>,
>(
  odsCode: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrganisationSites>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationSitesQueryOptions(odsCode, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a minimal subset of the user's onboarding data (role, org, registration body, work email verified status, approval status, and submission timestamp). This endpoint intentionally bypasses the approval gate so pending and rejected users can see what information is on file.
 * @summary Get a lightweight profile summary for the authenticated user — available before approval
 */
export const getGetHcpProfileSummaryUrl = () => {
  return `/api/user/profile-summary`;
};

export const getHcpProfileSummary = async (
  options?: RequestInit,
): Promise<HcpProfileSummary> => {
  return customFetch<HcpProfileSummary>(getGetHcpProfileSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetHcpProfileSummaryQueryKey = () => {
  return [`/api/user/profile-summary`] as const;
};

export const getGetHcpProfileSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getHcpProfileSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfileSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHcpProfileSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHcpProfileSummary>>
  > = ({ signal }) => getHcpProfileSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfileSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHcpProfileSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHcpProfileSummary>>
>;
export type GetHcpProfileSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a lightweight profile summary for the authenticated user — available before approval
 */

export function useGetHcpProfileSummary<
  TData = Awaited<ReturnType<typeof getHcpProfileSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfileSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHcpProfileSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the authenticated user's full HCP profile including onboarding fields
 */
export const getGetHcpProfileUrl = () => {
  return `/api/user/profile`;
};

export const getHcpProfile = async (
  options?: RequestInit,
): Promise<HcpProfile> => {
  return customFetch<HcpProfile>(getGetHcpProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetHcpProfileQueryKey = () => {
  return [`/api/user/profile`] as const;
};

export const getGetHcpProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getHcpProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHcpProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHcpProfile>>> = ({
    signal,
  }) => getHcpProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHcpProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHcpProfile>>
>;
export type GetHcpProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the authenticated user's full HCP profile including onboarding fields
 */

export function useGetHcpProfile<
  TData = Awaited<ReturnType<typeof getHcpProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHcpProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHcpProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update HCP onboarding profile fields (org, site, job role, band, work email)
 */
export const getUpdateHcpProfileUrl = () => {
  return `/api/user/profile`;
};

export const updateHcpProfile = async (
  hcpProfileUpdate: HcpProfileUpdate,
  options?: RequestInit,
): Promise<HcpProfile> => {
  return customFetch<HcpProfile>(getUpdateHcpProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(hcpProfileUpdate),
  });
};

export const getUpdateHcpProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHcpProfile>>,
    TError,
    { data: BodyType<HcpProfileUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHcpProfile>>,
  TError,
  { data: BodyType<HcpProfileUpdate> },
  TContext
> => {
  const mutationKey = ["updateHcpProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHcpProfile>>,
    { data: BodyType<HcpProfileUpdate> }
  > = (props) => {
    const { data } = props ?? {};

    return updateHcpProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHcpProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHcpProfile>>
>;
export type UpdateHcpProfileMutationBody = BodyType<HcpProfileUpdate>;
export type UpdateHcpProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update HCP onboarding profile fields (org, site, job role, band, work email)
 */
export const useUpdateHcpProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHcpProfile>>,
    TError,
    { data: BodyType<HcpProfileUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateHcpProfile>>,
  TError,
  { data: BodyType<HcpProfileUpdate> },
  TContext
> => {
  return useMutation(getUpdateHcpProfileMutationOptions(options));
};

/**
 * @summary Send a 6-digit OTP to the provided work email address
 */
export const getSendWorkEmailOtpUrl = () => {
  return `/api/user/send-work-email-otp`;
};

export const sendWorkEmailOtp = async (
  sendWorkEmailOtpInput: SendWorkEmailOtpInput,
  options?: RequestInit,
): Promise<SendWorkEmailOtpResult> => {
  return customFetch<SendWorkEmailOtpResult>(getSendWorkEmailOtpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendWorkEmailOtpInput),
  });
};

export const getSendWorkEmailOtpMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendWorkEmailOtp>>,
    TError,
    { data: BodyType<SendWorkEmailOtpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendWorkEmailOtp>>,
  TError,
  { data: BodyType<SendWorkEmailOtpInput> },
  TContext
> => {
  const mutationKey = ["sendWorkEmailOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendWorkEmailOtp>>,
    { data: BodyType<SendWorkEmailOtpInput> }
  > = (props) => {
    const { data } = props ?? {};

    return sendWorkEmailOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendWorkEmailOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendWorkEmailOtp>>
>;
export type SendWorkEmailOtpMutationBody = BodyType<SendWorkEmailOtpInput>;
export type SendWorkEmailOtpMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a 6-digit OTP to the provided work email address
 */
export const useSendWorkEmailOtp = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendWorkEmailOtp>>,
    TError,
    { data: BodyType<SendWorkEmailOtpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendWorkEmailOtp>>,
  TError,
  { data: BodyType<SendWorkEmailOtpInput> },
  TContext
> => {
  return useMutation(getSendWorkEmailOtpMutationOptions(options));
};

/**
 * @summary Verify the OTP sent to the work email
 */
export const getVerifyWorkEmailOtpUrl = () => {
  return `/api/user/verify-work-email-otp`;
};

export const verifyWorkEmailOtp = async (
  verifyWorkEmailOtpInput: VerifyWorkEmailOtpInput,
  options?: RequestInit,
): Promise<VerifyWorkEmailOtpResult> => {
  return customFetch<VerifyWorkEmailOtpResult>(getVerifyWorkEmailOtpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyWorkEmailOtpInput),
  });
};

export const getVerifyWorkEmailOtpMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyWorkEmailOtp>>,
    TError,
    { data: BodyType<VerifyWorkEmailOtpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyWorkEmailOtp>>,
  TError,
  { data: BodyType<VerifyWorkEmailOtpInput> },
  TContext
> => {
  const mutationKey = ["verifyWorkEmailOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyWorkEmailOtp>>,
    { data: BodyType<VerifyWorkEmailOtpInput> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyWorkEmailOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyWorkEmailOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyWorkEmailOtp>>
>;
export type VerifyWorkEmailOtpMutationBody = BodyType<VerifyWorkEmailOtpInput>;
export type VerifyWorkEmailOtpMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Verify the OTP sent to the work email
 */
export const useVerifyWorkEmailOtp = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyWorkEmailOtp>>,
    TError,
    { data: BodyType<VerifyWorkEmailOtpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyWorkEmailOtp>>,
  TError,
  { data: BodyType<VerifyWorkEmailOtpInput> },
  TContext
> => {
  return useMutation(getVerifyWorkEmailOtpMutationOptions(options));
};

/**
 * @summary Verify a professional registration number against the relevant UK regulator register
 */
export const getVerifyHcpRegistrationUrl = () => {
  return `/api/user/verify-registration`;
};

export const verifyHcpRegistration = async (
  verifyRegistrationInput: VerifyRegistrationInput,
  options?: RequestInit,
): Promise<VerifyRegistrationResult> => {
  return customFetch<VerifyRegistrationResult>(getVerifyHcpRegistrationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyRegistrationInput),
  });
};

export const getVerifyHcpRegistrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyHcpRegistration>>,
    TError,
    { data: BodyType<VerifyRegistrationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyHcpRegistration>>,
  TError,
  { data: BodyType<VerifyRegistrationInput> },
  TContext
> => {
  const mutationKey = ["verifyHcpRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyHcpRegistration>>,
    { data: BodyType<VerifyRegistrationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyHcpRegistration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyHcpRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyHcpRegistration>>
>;
export type VerifyHcpRegistrationMutationBody =
  BodyType<VerifyRegistrationInput>;
export type VerifyHcpRegistrationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Verify a professional registration number against the relevant UK regulator register
 */
export const useVerifyHcpRegistration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyHcpRegistration>>,
    TError,
    { data: BodyType<VerifyRegistrationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyHcpRegistration>>,
  TError,
  { data: BodyType<VerifyRegistrationInput> },
  TContext
> => {
  return useMutation(getVerifyHcpRegistrationMutationOptions(options));
};

/**
 * @summary Request a manual review when automated registration verification fails
 */
export const getRequestVerificationReviewUrl = () => {
  return `/api/user/request-verification-review`;
};

export const requestVerificationReview = async (
  options?: RequestInit,
): Promise<RequestVerificationReviewResult> => {
  return customFetch<RequestVerificationReviewResult>(
    getRequestVerificationReviewUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRequestVerificationReviewMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVerificationReview>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestVerificationReview>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["requestVerificationReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestVerificationReview>>,
    void
  > = () => {
    return requestVerificationReview(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestVerificationReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestVerificationReview>>
>;

export type RequestVerificationReviewMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a manual review when automated registration verification fails
 */
export const useRequestVerificationReview = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVerificationReview>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestVerificationReview>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRequestVerificationReviewMutationOptions(options));
};

/**
 * @summary List CPD learning modules
 */
export const getListModulesUrl = (params?: ListModulesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/modules?${stringifiedParams}`
    : `/api/modules`;
};

export const listModules = async (
  params?: ListModulesParams,
  options?: RequestInit,
): Promise<CpdModuleSummary[]> => {
  return customFetch<CpdModuleSummary[]>(getListModulesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListModulesQueryKey = (params?: ListModulesParams) => {
  return [`/api/modules`, ...(params ? [params] : [])] as const;
};

export const getListModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listModules>>,
  TError = ErrorType<unknown>,
>(
  params?: ListModulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listModules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModulesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModules>>> = ({
    signal,
  }) => listModules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModules>>
>;
export type ListModulesQueryError = ErrorType<unknown>;

/**
 * @summary List CPD learning modules
 */

export function useListModules<
  TData = Awaited<ReturnType<typeof listModules>>,
  TError = ErrorType<unknown>,
>(
  params?: ListModulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listModules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListModulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the authenticated user's progress across all modules
 */
export const getGetMyModuleProgressUrl = () => {
  return `/api/modules/my-progress`;
};

export const getMyModuleProgress = async (
  options?: RequestInit,
): Promise<CpdModuleProgress[]> => {
  return customFetch<CpdModuleProgress[]>(getGetMyModuleProgressUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyModuleProgressQueryKey = () => {
  return [`/api/modules/my-progress`] as const;
};

export const getGetMyModuleProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyModuleProgress>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyModuleProgress>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyModuleProgressQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyModuleProgress>>
  > = ({ signal }) => getMyModuleProgress({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyModuleProgress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyModuleProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyModuleProgress>>
>;
export type GetMyModuleProgressQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the authenticated user's progress across all modules
 */

export function useGetMyModuleProgress<
  TData = Awaited<ReturnType<typeof getMyModuleProgress>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyModuleProgress>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyModuleProgressQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a CPD module by ID including full section content
 */
export const getGetModuleUrl = (id: number) => {
  return `/api/modules/${id}`;
};

export const getModule = async (
  id: number,
  options?: RequestInit,
): Promise<CpdModule> => {
  return customFetch<CpdModule>(getGetModuleUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetModuleQueryKey = (id: number) => {
  return [`/api/modules/${id}`] as const;
};

export const getGetModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getModule>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getModule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModule>>> = ({
    signal,
  }) => getModule(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetModuleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModule>>
>;
export type GetModuleQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a CPD module by ID including full section content
 */

export function useGetModule<
  TData = Awaited<ReturnType<typeof getModule>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getModule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetModuleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a section as complete (or undo) for the authenticated user
 */
export const getUpdateModuleProgressUrl = (id: number) => {
  return `/api/modules/${id}/progress`;
};

export const updateModuleProgress = async (
  id: number,
  updateModuleProgressInput: UpdateModuleProgressInput,
  options?: RequestInit,
): Promise<CpdModuleProgress> => {
  return customFetch<CpdModuleProgress>(getUpdateModuleProgressUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateModuleProgressInput),
  });
};

export const getUpdateModuleProgressMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleProgress>>,
    TError,
    { id: number; data: BodyType<UpdateModuleProgressInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModuleProgress>>,
  TError,
  { id: number; data: BodyType<UpdateModuleProgressInput> },
  TContext
> => {
  const mutationKey = ["updateModuleProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleProgress>>,
    { id: number; data: BodyType<UpdateModuleProgressInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateModuleProgress(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModuleProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModuleProgress>>
>;
export type UpdateModuleProgressMutationBody =
  BodyType<UpdateModuleProgressInput>;
export type UpdateModuleProgressMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Mark a section as complete (or undo) for the authenticated user
 */
export const useUpdateModuleProgress = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleProgress>>,
    TError,
    { id: number; data: BodyType<UpdateModuleProgressInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModuleProgress>>,
  TError,
  { id: number; data: BodyType<UpdateModuleProgressInput> },
  TContext
> => {
  return useMutation(getUpdateModuleProgressMutationOptions(options));
};

/**
 * @summary List all consultation records for a patient (clinician only, access-scoped)
 */
export const getListPatientConsultationsUrl = (patientId: number) => {
  return `/api/patients/${patientId}/consultations`;
};

export const listPatientConsultations = async (
  patientId: number,
  options?: RequestInit,
): Promise<ConsultationRecord[]> => {
  return customFetch<ConsultationRecord[]>(
    getListPatientConsultationsUrl(patientId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPatientConsultationsQueryKey = (patientId: number) => {
  return [`/api/patients/${patientId}/consultations`] as const;
};

export const getListPatientConsultationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPatientConsultations>>,
  TError = ErrorType<void>,
>(
  patientId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPatientConsultations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPatientConsultationsQueryKey(patientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPatientConsultations>>
  > = ({ signal }) =>
    listPatientConsultations(patientId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!patientId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPatientConsultations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPatientConsultationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPatientConsultations>>
>;
export type ListPatientConsultationsQueryError = ErrorType<void>;

/**
 * @summary List all consultation records for a patient (clinician only, access-scoped)
 */

export function useListPatientConsultations<
  TData = Awaited<ReturnType<typeof listPatientConsultations>>,
  TError = ErrorType<void>,
>(
  patientId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPatientConsultations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPatientConsultationsQueryOptions(
    patientId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new consultation record for a patient (nurse or doctor only)
 */
export const getCreateConsultationRecordUrl = (patientId: number) => {
  return `/api/patients/${patientId}/consultations`;
};

export const createConsultationRecord = async (
  patientId: number,
  createConsultationRecordInput: CreateConsultationRecordInput,
  options?: RequestInit,
): Promise<ConsultationRecord> => {
  return customFetch<ConsultationRecord>(
    getCreateConsultationRecordUrl(patientId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createConsultationRecordInput),
    },
  );
};

export const getCreateConsultationRecordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConsultationRecord>>,
    TError,
    { patientId: number; data: BodyType<CreateConsultationRecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConsultationRecord>>,
  TError,
  { patientId: number; data: BodyType<CreateConsultationRecordInput> },
  TContext
> => {
  const mutationKey = ["createConsultationRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConsultationRecord>>,
    { patientId: number; data: BodyType<CreateConsultationRecordInput> }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createConsultationRecord(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConsultationRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConsultationRecord>>
>;
export type CreateConsultationRecordMutationBody =
  BodyType<CreateConsultationRecordInput>;
export type CreateConsultationRecordMutationError = ErrorType<void>;

/**
 * @summary Create a new consultation record for a patient (nurse or doctor only)
 */
export const useCreateConsultationRecord = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConsultationRecord>>,
    TError,
    { patientId: number; data: BodyType<CreateConsultationRecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createConsultationRecord>>,
  TError,
  { patientId: number; data: BodyType<CreateConsultationRecordInput> },
  TContext
> => {
  return useMutation(getCreateConsultationRecordMutationOptions(options));
};

/**
 * @summary Get a single consultation record (author or practice lead)
 */
export const getGetConsultationRecordUrl = (id: number) => {
  return `/api/consultations/${id}`;
};

export const getConsultationRecord = async (
  id: number,
  options?: RequestInit,
): Promise<ConsultationRecord> => {
  return customFetch<ConsultationRecord>(getGetConsultationRecordUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetConsultationRecordQueryKey = (id: number) => {
  return [`/api/consultations/${id}`] as const;
};

export const getGetConsultationRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof getConsultationRecord>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsultationRecord>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConsultationRecordQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConsultationRecord>>
  > = ({ signal }) => getConsultationRecord(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConsultationRecord>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConsultationRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConsultationRecord>>
>;
export type GetConsultationRecordQueryError = ErrorType<void>;

/**
 * @summary Get a single consultation record (author or practice lead)
 */

export function useGetConsultationRecord<
  TData = Awaited<ReturnType<typeof getConsultationRecord>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsultationRecord>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConsultationRecordQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a consultation record (author or practice lead)
 */
export const getUpdateConsultationRecordUrl = (id: number) => {
  return `/api/consultations/${id}`;
};

export const updateConsultationRecord = async (
  id: number,
  updateConsultationRecordInput: UpdateConsultationRecordInput,
  options?: RequestInit,
): Promise<ConsultationRecord> => {
  return customFetch<ConsultationRecord>(getUpdateConsultationRecordUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateConsultationRecordInput),
  });
};

export const getUpdateConsultationRecordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConsultationRecord>>,
    TError,
    { id: number; data: BodyType<UpdateConsultationRecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConsultationRecord>>,
  TError,
  { id: number; data: BodyType<UpdateConsultationRecordInput> },
  TContext
> => {
  const mutationKey = ["updateConsultationRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConsultationRecord>>,
    { id: number; data: BodyType<UpdateConsultationRecordInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateConsultationRecord(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConsultationRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConsultationRecord>>
>;
export type UpdateConsultationRecordMutationBody =
  BodyType<UpdateConsultationRecordInput>;
export type UpdateConsultationRecordMutationError = ErrorType<void>;

/**
 * @summary Update a consultation record (author or practice lead)
 */
export const useUpdateConsultationRecord = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConsultationRecord>>,
    TError,
    { id: number; data: BodyType<UpdateConsultationRecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConsultationRecord>>,
  TError,
  { id: number; data: BodyType<UpdateConsultationRecordInput> },
  TContext
> => {
  return useMutation(getUpdateConsultationRecordMutationOptions(options));
};

/**
 * @summary Generate a draft GP letter from a consultation record
 */
export const getGetConsultationGpLetterUrl = (id: number) => {
  return `/api/consultations/${id}/gp-letter`;
};

export const getConsultationGpLetter = async (
  id: number,
  options?: RequestInit,
): Promise<ConsultationGpLetter> => {
  return customFetch<ConsultationGpLetter>(getGetConsultationGpLetterUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetConsultationGpLetterQueryKey = (id: number) => {
  return [`/api/consultations/${id}/gp-letter`] as const;
};

export const getGetConsultationGpLetterQueryOptions = <
  TData = Awaited<ReturnType<typeof getConsultationGpLetter>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsultationGpLetter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConsultationGpLetterQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConsultationGpLetter>>
  > = ({ signal }) =>
    getConsultationGpLetter(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConsultationGpLetter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConsultationGpLetterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConsultationGpLetter>>
>;
export type GetConsultationGpLetterQueryError = ErrorType<void>;

/**
 * @summary Generate a draft GP letter from a consultation record
 */

export function useGetConsultationGpLetter<
  TData = Awaited<ReturnType<typeof getConsultationGpLetter>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsultationGpLetter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConsultationGpLetterQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Search across conditions, medications, guidelines (professionals only), and scenarios (professionals only)
 */
export const getGlobalSearchUrl = (params: GlobalSearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/search?${stringifiedParams}`
    : `/api/search`;
};

export const globalSearch = async (
  params: GlobalSearchParams,
  options?: RequestInit,
): Promise<SearchResultItem[]> => {
  return customFetch<SearchResultItem[]>(getGlobalSearchUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGlobalSearchQueryKey = (params?: GlobalSearchParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getGlobalSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof globalSearch>>,
  TError = ErrorType<void>,
>(
  params: GlobalSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof globalSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalSearch>>> = ({
    signal,
  }) => globalSearch(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalSearch>>
>;
export type GlobalSearchQueryError = ErrorType<void>;

/**
 * @summary Search across conditions, medications, guidelines (professionals only), and scenarios (professionals only)
 */

export function useGlobalSearch<
  TData = Awaited<ReturnType<typeof globalSearch>>,
  TError = ErrorType<void>,
>(
  params: GlobalSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof globalSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
